export default {
  translation: {
    common: {
      delete: 'Löschen',
      clear: 'Schließen',
      back: 'Zurück',
      deleteModalTitle:
        'Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?',
      ok: 'Ja',
      selectAll: 'Alle auswählen',
      cancel: 'Nein',
      total: 'Gesamt',
      search: 'Suchen',
      rename: 'Umbenennen',
      noData: "Keine Daten vorhanden",
      name: 'Name',
      save: 'Speichern',
      namePlaceholder: 'Bitte Namen eingeben',
      selectPlaceholder: 'Auswählen',
      next: 'Weiter',
      create: 'Erstellen',
      edit: 'Bearbeiten',
      upload: 'Hochladen',
      english: 'Englisch',
      portugueseBr: 'Portugiesisch (Brasilien)',
      chinese: 'Vereinfachtes Chinesisch',
      traditionalChinese: 'Traditionelles Chinesisch',
      german: 'Deutsch',
      language: 'Sprache',
      languageMessage: 'Bitte geben Sie Ihre Sprache ein!',
      languagePlaceholder: 'Wählen Sie Ihre Sprache',
      copy: 'Kopieren',
      copied: 'Kopiert',
      comingSoon: 'Demnächst verfügbar',
      confirm: 'Bestätigen',
      download: 'Herunterladen',
      close: 'Schließen',
      preview: 'Vorschau',
      move: 'Verschieben',
      warn: 'Warnung',
      action: 'Aktion',
      noDataFound: 'Keine Daten gefunden.',
      s: 'S',
      pleaseSelect: 'Bitte auswählen',
      pleaseInput: 'Bitte eingeben',
      submit: 'Bestätigen',
      embedIntoSite: 'In Webseite einbetten',
      previousPage: 'Zurück',
      nextPage: 'Weiter',
      noResults: 'Keine Ergebnisse',
      deleted: 'Gelöscht!',
      saved: "Gespeichert!",
      saveFailed: 'Speichern fehlgeschlagen',
      deleteFailed: 'Löschen fehlgeschlagen',
      loading: 'Wird geladen...',
    },
    login: {
      login: 'Anmelden',
      loginTitle: 'Melden Sie sich in Ihrem Account an',
      signUp: 'Registrieren',
      signUpTitle: 'Erstellen Sie einen neuen Account',
      loginDescription: 'Wir freuen uns, Sie wiederzusehen!',
      registerDescription: 'Schön, Sie an Bord zu haben!',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'Bitte E-Mail eingeben',
      passwordLabel: 'Passwort',
      passwordPlaceholder: 'Bitte Passwort eingeben',
      rememberMe: 'Angemeldet bleiben',
      signInTip: 'Noch kein Konto?',
      signUpTip: 'Bereits ein Konto?',
      nicknameLabel: 'Name',
      nicknamePlacehold: 'Bitte Namen eingeben',
      register: 'Konto erstellen',
      continue: 'Fortfahren',
      title: 'Willkommen beim optimAIse-System für Münchinger',
      description: '',
      review: 'von über 500 Bewertungen',
      changePasswordTitle: 'Initiales Passwort ändern',
      changePasswordSubtitle: 'Bitte vergeben Sie ein neues Passwort. Dieses Passwort sollte nur Ihnen bekannt sein um Ihren Account vor unberechtigtem Zugriff zu schützen.',
      newPassword: 'Neues Passwort',
      newPasswordPlaceholder: 'Neues Passwort eingeben',
      confirmPassword: 'Neues Passwort wiederholen',
      confirmPasswordPlaceholder: 'Neues Passwort eingeben',
      savePassword: 'Passwort speichern',
      passwordMinLength: 'Das Passwort muss mindestens 8 Zeichen haben!',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      passwordChanged: 'Passwort erfolgreich geändert!',
    },
    header: {
      knowledgeBase: 'Wissensdatenbank',
      chat: 'Chat-Assistenten',
      register: 'Registrieren',
      signin: 'Anmelden',
      home: 'Startseite',
      setting: 'Benutzereinstellungen',
      logout: 'Abmelden',
      fileManager: 'Dateiverwaltung',
      flow: 'Agent',
      search: 'Suche in TFI',
      welcome: 'Willkommen zu ',
      dataset: 'Datensatz',
      Memories: 'Speicher',
      dialog: 'Chat-Apps',
      evaluation: 'Evaluierung',
    },
    memories: {
      memory: 'Speicher',
      createMemory: 'Speicher erstellen',
      name: 'Name',
      memoryNamePlaceholder: 'Name des Speichers',
      memoryType: 'Speichertyp',
      embeddingModel: 'Embedding-Modell',
      selectModel: 'Modell auswählen',
      llm: 'LLM',
      delMemoryWarn: `Nach dem Löschen werden alle Nachrichten in diesem Speicher gelöscht und können von Agenten nicht wiederhergestellt werden.`,
    },
    memory: {
      messages: {
        copied: 'Kopiert!',
        contentEmbed: 'Inhaltseinbettung',
        content: 'Inhalt',
        delMessageWarn: `Nach dem Vergessen wird diese Nachricht von Agenten nicht mehr abgerufen.`,
        forgetMessage: 'Nachricht vergessen',
        sessionId: 'Sitzungs-ID',
        agent: 'Agent',
        type: 'Typ',
        validDate: 'Gültigkeitsdatum',
        forgetAt: 'Vergessen am',
        source: 'Quelle',
        enable: 'Aktivieren',
        action: 'Aktion',
      },
      config: {
        avatar: 'Avatar',
        description: 'Beschreibung',
        memorySize: 'Speichergröße',
        advancedSettings: 'Erweiterte Einstellungen',
        permission: 'Berechtigung',
        onlyMe: 'Nur ich',
        team: 'Team',
        storageType: 'Speichertyp',
        storageTypePlaceholder: 'Bitte Speichertyp auswählen',
        forgetPolicy: 'Vergessensrichtlinie',
        temperature: 'Temperatur',
        systemPrompt: 'System-Prompt',
        systemPromptPlaceholder: 'Bitte System-Prompt eingeben',
        userPrompt: 'Benutzer-Prompt',
        userPromptPlaceholder: 'Bitte Benutzer-Prompt eingeben',
      },
      sideBar: {
        messages: 'Nachrichten',
        configuration: 'Konfiguration',
      },
    },
    language: {
      english: 'English',
      german: 'Deutsch',
    },
    knowledgeList: {
      welcome: 'Willkommen zurück',
      description: 'Welche Wissensdatenbanken möchten Sie heute nutzen?',
      createKnowledgeBase: 'Wissensdatenbank erstellen',
      name: 'Name',
      namePlaceholder: 'Bitte Namen eingeben!',
      doc: 'Dokumente',
      searchKnowledgePlaceholder: 'Suchen',
      noMoreData: `Das war's. Nichts mehr zu sehen.`,
    },
    datasetOverview: {
      downloadTip: 'Dateien werden aus Datenquellen heruntergeladen.',
      processingTip: 'Dateien werden von der Ingestions-Pipeline verarbeitet.',
      totalFiles: 'Dateien insgesamt',
      downloading: 'Wird heruntergeladen',
      downloadSuccessTip: 'Erfolgreich heruntergeladene Dateien insgesamt',
      downloadFailedTip: 'Fehlgeschlagene Downloads insgesamt',
      processingSuccessTip: 'Erfolgreich verarbeitete Dateien insgesamt',
      processingFailedTip: 'Fehlgeschlagene Verarbeitungen insgesamt',
      processing: 'Verarbeitung',
      noData: 'Noch keine Protokolle',
    },
    chunk: {
      chunk: 'Chunk',
      bulk: 'Massenaktion',
      selectAll: 'Alle auswählen',
      enabledSelected: 'Ausgewählte aktivieren',
      disabledSelected: 'Ausgewählte deaktivieren',
      deleteSelected: 'Ausgewählte löschen',
      search: 'Suchen',
      all: 'Alle',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      keyword: 'Stichwort',
      function: 'Funktion',
      chunkMessage: 'Bitte Wert eingeben!',
      full: 'Volltext',
      ellipse: 'Ellipse',
      graph: 'Wissensgraph',
      mind: 'Mindmap',
      question: 'Frage',
      questionTip: `Wenn Fragen angegeben sind, basiert das Embedding des Chunks auf diesen.`,
      chunkResult: 'Chunk-Ergebnis',
      chunkResultTip: `Anzeige der gechunkten Segmente, die für Embedding und Retrieval verwendet werden.`,
      enable: 'Aktivieren',
      disable: 'Deaktivieren',
      delete: 'Löschen',  
    },
    knowledgeDetails: {
      fileType: 'Dateityp',
      generateKnowledgeGraph: 'Dies extrahiert Entitäten und Beziehungen aus allen Ihren Dokumenten in diesem Datensatz. Der Vorgang kann eine Weile dauern, bis er abgeschlossen ist.',
      generateRaptor:'Führt rekursives Clustering und Zusammenfassungen von Dokumentabschnitten durch, um eine hierarchische Baumstruktur zu erstellen, die eine kontextbewusstere Abfrage über umfangreiche Dokumente hinweg ermöglicht.',
      generate: 'Erstellen',
      raptor: 'RAPTOR',
      uploadedBy: 'Hochgeladen von',
      dataset: 'Datensatz',
      close: 'Schließen',
      testing: 'Abruftest',
      testResults: 'Ergebnisse',
      files: 'Dateien',
      noTestResultsForRuned: 'Keine relevanten Ergenisse gefunden.',
      noTestResultsForNotRuned:'Kein Test wurde ausgeführt. Die Ergebnisse werden hier erscheinen.',
      subbarFiles: 'Dateien',
      overview: 'Logs',
      processingType: 'Verarbeitungstyp',
      dataPipeline: 'Ingestions-Pipeline',
      operations: 'Operationen',
      taskId: 'Aufgaben-ID',
      duration: 'Dauer',
      details: 'Details',
      status: 'Status',
      task: 'Aufgabe',
      startDate: 'Startdatum',
      source: 'Quelle',
      fileName: 'Dateiname',
      datasetLogs: 'Datensatz',
      fileLogs: 'Datei',
      success: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      completed: 'Abgeschlossen',
      datasetLog: 'Datensatzprotokoll',
      created: 'Erstellt',
      Parse: 'Parsing-Methode',
      learnMore: 'Einführung in die integrierte Pipeline',
      general: 'Allgemein',
      chunkMethodTab: 'Chunk-Methode',
      configuration: 'Konfiguration',
      testSetting: 'Einstellungen',
      knowledgeGraph: 'Wissensgraph',
      retrievalTesting: 'Retrieval Test',
      name: 'Name',
      namePlaceholder: 'Bitte Namen eingeben!',
      doc: 'Dokumente',
      datasetDescription:
        'Bitte warten Sie, bis die Analyse Ihrer Datei abgeschlossen ist, bevor Sie einen KI-gestützten Chat starten.',
      addFile: 'Datei hinzufügen',
      searchFiles: 'Durchsuchen Sie Ihre Dateien',
      localFiles: 'Lokale Dateien',
      emptyFiles: 'Leere Datei erstellen',
      webCrawl: 'Web-Crawling',
      chunkNumber: 'Chunk-Anzahl',
      uploadDate: 'Hochladedatum',
      chunkMethod: 'Chunk-Methode',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      action: 'Aktion',
      parsingStatus: 'Analysestatus',
      parsingStatusTip:
        'Die Verarbeitungszeit für Dokumente variiert je nach mehreren Faktoren. Das Aktivieren von Funktionen wie Knowledge Graph, RAPTOR, automatischer Frage- oder Schlüsselwort-Extraktion verlängert die Bearbeitungszeit deutlich.',
      processBeginAt: 'Beginn',
      processDuration: 'Dauer',
      progressMsg: 'Fortschritt',
      testingDescription:
        'Führen Sie einen Abruftest durch, um zu prüfen, ob optimAIse RAG die beabsichtigten Inhalte für das LLM wiederherstellen kann.',
      similarityThreshold: 'Ähnlichkeitsschwelle',
      similarityThresholdTip:
        'optimAIse RAG verwendet entweder eine Kombination aus gewichteter Schlüsselwortähnlichkeit und gewichteter Vektorkosinus-Ähnlichkeit oder eine Kombination aus gewichteter Schlüsselwortähnlichkeit und gewichteter Neuordnungsbewertung während des Abrufs. Dieser Parameter legt den Schwellenwert für Ähnlichkeiten zwischen der Benutzeranfrage und den Chunks fest. Jeder Chunk mit einer Ähnlichkeitsbewertung unter diesem Schwellenwert wird von den Ergebnissen ausgeschlossen. Standardmäßig ist der Schwellenwert auf 0,2 festgelegt. Das bedeutet, dass nur Textblöcke mit einer hybriden Ähnlichkeitsbewertung von 20 oder höher abgerufen werden.',
      vectorSimilarityWeight: 'Schlüsselwortähnlichkeitsgewicht',
      vectorSimilarityWeightTip:
        'Dies legt das Gewicht der Schlüsselwortähnlichkeit im kombinierten Ähnlichkeitswert fest, entweder in Verbindung mit der Vektorkosinus-Ähnlichkeit oder mit der Neuordnungsbewertung. Die Summe der beiden Gewichte muss 1,0 ergeben.',
      testText: 'Testtext',
      testTextPlaceholder: 'Geben Sie hier Ihre Frage ein!',
      testingLabel: 'Testen',
      similarity: 'Hybride Ähnlichkeit',
      termSimilarity: 'Begriffsähnlichkeit',
      vectorSimilarity: 'Vektorähnlichkeit',
      hits: 'Treffer',
      view: 'Ansehen',
      filesSelected: 'Dateien ausgewählt',
      upload: 'Hochladen',
      run: 'Analysieren',
      runningStatus0: 'AUSSTEHEND',
      runningStatus1: 'WIRD ANALYSIERT',
      runningStatus2: 'ABGEBROCHEN',
      runningStatus3: 'ERFOLGREICH',
      runningStatus4: 'FEHLGESCHLAGEN',
      pageRanges: 'Seitenbereiche',
      pageRangesTip:
        'Bereich der zu analysierenden Seiten; Seiten außerhalb dieses Bereichs werden nicht verarbeitet.',
      fromPlaceholder: 'von',
      fromMessage: 'Anfangsseitennummer fehlt',
      toPlaceholder: 'bis',
      toMessage: 'Endseitennummer fehlt (ausgeschlossen)',
      layoutRecognize: 'Dokumentenparser',
      layoutRecognizeTip:
        'Verwendet ein visuelles Modell für die PDF-Layout-Analyse, um Dokumententitel, Textblöcke, Bilder und Tabellen effektiv zu lokalisieren. Wenn die einfache Option gewählt wird, wird nur der reine Text im PDF abgerufen. Bitte beachten Sie, dass diese Option derzeit NUR für PDF-Dokumente funktioniert.',
      taskPageSize: 'Aufgabenseitengröße',
      taskPageSizeMessage: 'Bitte geben Sie die Größe der Aufgabenseite ein!',
      taskPageSizeTip:
        'Während der Layouterkennung wird eine PDF-Datei in Chunks aufgeteilt und parallel verarbeitet, um die Verarbeitungsgeschwindigkeit zu erhöhen. Dieser Parameter legt die Größe jedes Chunks fest. Eine größere Chunk-Größe verringert die Wahrscheinlichkeit, dass fortlaufender Text zwischen den Seiten aufgeteilt wird.',
      addPage: 'Seite hinzufügen',
      greaterThan: 'Der aktuelle Wert muss größer als "bis" sein!',
      greaterThanPrevious:
        'Der aktuelle Wert muss größer als der vorherige "bis"-Wert sein!',
      selectFiles: 'Dateien auswählen',
      changeSpecificCategory: 'Spezifische Kategorie ändern',
      uploadTitle: 'Ziehen Sie Ihre Datei hierher, um sie hochzuladen',
      uploadDescription:
        'optimAIse RAG unterstützt das Hochladen von Dateien einzeln oder in Batches. Die maximale Dateigröße pro Upload beträgt 1 GB, mit einem Batch-Upload-Limit von 32 Dateien. Es gibt keine Begrenzung der Gesamtanzahl an Dateien pro Konto.',
      chunk: 'Chunk',
      bulk: 'Masse',
      cancel: 'Abbrechen',
      rerankModel: 'Neuordnungsmodell',
      rerankPlaceholder: 'Bitte auswählen',
      rerankTip:
        'Wenn leer gelassen, verwendet optimAIse RAG eine Kombination aus gewichteter Schlüsselwortähnlichkeit und gewichteter Vektorkosinus-Ähnlichkeit; wenn ein Neuordnungsmodell ausgewählt wird, ersetzt eine gewichtete Neuordnungsbewertung die gewichtete Vektorkosinus-Ähnlichkeit. Bitte beachten Sie, dass die Verwendung eines Neuordnungsmodells die Antwortzeit des Systems erheblich erhöht.',
      topK: 'Top-K',
      topKTip:
        'In Verbindung mit dem Rerank model wird mit dieser Einstellung die Anzahl der Textblöcke festgelegt, die an das angegebene reranking model gesendet werden.',
      delimiter: 'Trennzeichen für Textsegmentierung',
      delimiterTip:
        'Ein Trennzeichen oder Separator kann aus einem oder mehreren Sonderzeichen bestehen. Bei mehreren Zeichen stellen Sie sicher, dass sie in Backticks (` `) eingeschlossen sind. Wenn Sie beispielsweise Ihre Trennzeichen so konfigurieren: \\n`##`;, dann werden Ihre Texte an Zeilenumbrüchen, doppelten Rautenzeichen (##) oder Semikolons getrennt. Setzen Sie Trennzeichen nur nachdem Sie das Mechanismus der Textsegmentierung und -chunking verstanden haben.',
      html4excel: 'Excel zu HTML',
      html4excelTip:
        'Verwenden Sie dies zusammen mit der General-Schnittmethode. Wenn deaktiviert, werden Tabellenkalkulationsdateien (XLSX, XLS (Excel 97-2003)) zeilenweise in Schlüssel-Wert-Paare analysiert. Wenn aktiviert, werden Tabellenkalkulationsdateien in HTML-Tabellen umgewandelt. Wenn die ursprüngliche Tabelle mehr als 12 Zeilen enthält, teilt das System sie automatisch alle 12 Zeilen in mehrere HTML-Tabellen auf.',
      autoKeywords: 'Auto-Schlüsselwort',
      autoKeywordsTip:
        'Extrahieren Sie automatisch N Schlüsselwörter für jeden Abschnitt, um deren Ranking in Abfragen mit diesen Schlüsselwörtern zu verbessern. Beachten Sie, dass zusätzliche Tokens vom in den "Systemmodelleinstellungen" angegebenen Chat-Modell verbraucht werden. Sie können die hinzugefügten Schlüsselwörter eines Abschnitts in der Abschnittsliste überprüfen oder aktualisieren.',
      autoQuestions: 'Auto-Frage',
      autoQuestionsTip:
        'Um die Ranking-Ergebnisse zu verbessern, extrahieren Sie N Fragen für jeden Wissensdatenbank-Chunk mithilfe des im "Systemmodell-Setup" definierten Chatmodells. Beachten Sie, dass dies zusätzliche Token verbraucht. Die Ergebnisse können in der Chunk-Liste eingesehen und bearbeitet werden. Fehler bei der Fragenextraktion blockieren den Chunking-Prozess nicht; leere Ergebnisse werden dem ursprünglichen Chunk hinzugefügt.',
      redo: 'Möchten Sie die vorhandenen {{chunkNum}} Chunks löschen?',
      setMetaData: 'Metadaten festlegen',
      pleaseInputJson: 'Bitte JSON eingeben',
      documentMetaTips: `<p>Die Metadaten liegen im JSON-Format vor (nicht durchsuchbar). Sie werden dem Prompt für das LLM hinzugefügt, wenn Chunks dieses Dokuments im Prompt enthalten sind.</p>
  <p>Beispiele:</p>
  <b>Die Metadaten sind:</b><br>
  <code>
    {
        "Author": "Alex Dowson",
        "Date": "2024-11-12"
    }
  </code><br>
  <b>Der Prompt wird sein:</b><br>
  <p>Dokument: the_name_of_document</p>
  <p>Autor: Alex Dowson</p>
  <p>Datum: 2024-11-12</p>
  <p>Relevante Fragmente wie folgt:</p>
  <ul>
  <li>  Hier ist der Chunk-Inhalt....</li>
  <li>  Hier ist der Chunk-Inhalt....</li>
  </ul>
  `,
      metaData: 'Metadaten',
      deleteDocumentConfirmContent:
        'Das Dokument ist mit dem Wissensgraphen verknüpft. Nach dem Löschen werden die zugehörigen Knoten- und Beziehungsinformationen gelöscht, aber der Graph wird nicht sofort aktualisiert. Die Aktualisierung des Graphen erfolgt während des Analyseprozesses des neuen Dokuments, das die Aufgabe zur Extraktion des Wissensgraphen enthält.',
      plainText: 'Einfach',
    },
    knowledgeConfiguration: {
      titleDescription:
        'Aktualisieren Sie hier Ihre Wissensdatenbank-Konfiguration, insbesondere die Chunk-Methode.',
      name: 'Name der Wissensdatenbank',
      photo: 'Bild der Wissensdatenbank',
      description: 'Beschreibung',
      language: 'Dokumentensprache',
      languageMessage: 'Bitte geben Sie Ihre Sprache ein!',
      languagePlaceholder: 'Bitte geben Sie Ihre Sprache ein!',
      permissions: 'Berechtigungen',
      embeddingModel: 'Embedding-Modell',
      chunkTokenNumber: 'Empfohlene Chunk-Größe',
      chunkTokenNumberMessage: 'Chunk-Token-Anzahl ist erforderlich',
      parseType: 'Parsing-Typ',
      builtIn: 'Vordefiniert Pipeline',
      manualSetup: 'Manuelle Pipeline',
      dataFlowPlaceholder: 'Bitte wählen Sie eine Pipeline aus',
      embeddingModelTip:
        'Das Standard-Embedding-Modell der Wissensdatenbank. Es kann nicht geändert werden, sobald die Wissensdatenbank Chunks enthält. Um zu einem anderen Standard-Embedding-Modell zu wechseln, müssen alle vorhandenen Chunks in der Wissensdatenbank gelöscht werden.',
      permissionsTip:
        'Wenn auf "Team" gesetzt, können alle Teammitglieder die Wissensdatenbank verwalten.',
      chunkTokenNumberTip:
        'Legt den Token-Schwellenwert für einen Chunk fest. Ein Absatz mit weniger Tokens als dieser Schwellenwert wird mit dem folgenden Absatz kombiniert, bis die Token-Anzahl den Schwellenwert überschreitet, dann wird ein Chunk erstellt. Ein neuer Block wird nicht erstellt, es sei denn, ein Trennzeichen wird gefunden, auch wenn dieser Schwellenwert überschritten wird.',
      chunkMethod: 'Chunk-Methode',
      chunkMethodTip: 'Siehe Tipps auf der rechten Seite.',
      upload: 'Hochladen',
      english: 'Englisch',
      chinese: 'Chinesisch',
      portugueseBr: 'Portugiesisch (Brasilien)',
      embeddingModelPlaceholder: 'Bitte wählen Sie ein Embedding-Modell',
      chunkMethodPlaceholder: 'Bitte wählen Sie eine Chunk-Methode',
      save: 'Speichern',
      me: 'Nur ich',
      team: 'Team',
      cancel: 'Abbrechen',
      methodTitle: 'Beschreibung der Chunk-Methode',
      methodExamples: 'Beispiele',
      methodExamplesDescription:
        'Um Ihnen das Verständnis zu erleichtern, haben wir relevante Screenshots als Referenz bereitgestellt.',
      dialogueExamplesTitle: 'Dialogbeispiele',
      methodEmpty:
        'Hier wird eine visuelle Erklärung der Wissensdatenbank-Kategorien angezeigt',
      book: `<p>Unterstützte Dateiformate sind <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
        Für jedes Buch im PDF-Format stellen Sie bitte die <i>Seitenbereiche</i> ein, um unerwünschte Informationen zu entfernen und die Analysezeit zu reduzieren.</p>`,
      laws: `<p>Unterstützte Dateiformate sind <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
        Rechtliche Dokumente folgen in der Regel einem strengen Schreibformat. Wir verwenden Textmerkmale, um Teilungspunkte zu identifizieren. 
        </p><p>
        Der Chunk hat eine Granularität, die mit 'ARTIKEL' übereinstimmt, wobei sichergestellt wird, dass der gesamte übergeordnete Text im Chunk enthalten ist.
        </p>`,
      manual: `<p>Nur <b>PDF</b> wird unterstützt.</p><p>
        Wir gehen davon aus, dass das Handbuch eine hierarchische Abschnittsstruktur aufweist und verwenden die Titel der untersten Abschnitte als Grundeinheit für die Aufteilung der Dokumente. Daher werden Abbildungen und Tabellen im selben Abschnitt nicht getrennt, was zu größeren Chunk-Größen führen kann.
        </p>`,
      naive: `<p>Unterstützte Dateiformate sind <b>MD, MDX, DOCX, XLSX, XLS (Excel 97-2003), PPT, PDF, TXT, JPEG, JPG, PNG, TIF, GIF, CSV, JSON, EML, HTML</b>.</p>
        <p>Diese Methode teilt Dateien mit einer 'naiven' Methode auf: </p>
        <p>
        <li>Verwenden eines Erkennungsmodells, um die Texte in kleinere Segmente aufzuteilen.</li>
        <li>Dann werden benachbarte Segmente kombiniert, bis die Token-Anzahl den durch 'Chunk-Token-Anzahl' festgelegten Schwellenwert überschreitet, woraufhin ein Chunk erstellt wird.</li></p>`,
      paper: `<p>Nur <b>PDF</b>-Dateien werden unterstützt.</p><p>
        Papers werden nach Abschnitten wie <i>abstract, 1.1, 1.2</i> aufgeteilt. </p><p>
        Dieser Ansatz ermöglicht es dem LLM, das Paper effektiver zusammenzufassen und umfassendere, verständlichere Antworten zu liefern. 
        Es erhöht jedoch auch den Kontext für KI-Gespräche und die Rechenkosten für das LLM. Daher sollten Sie während eines Gesprächs erwägen, den Wert von '<b>topN</b>' zu reduzieren.</p>`,
      presentation: `<p>Unterstützte Dateiformate sind <b>PDF</b>, <b>PPTX</b>.</p><p>
        Jede Seite in den Folien wird als Chunk behandelt, wobei ihr Vorschaubild gespeichert wird.</p><p>
        <i>Diese Chunk-Methode wird automatisch auf alle hochgeladenen PPT-Dateien angewendet, Sie müssen sie also nicht manuell angeben.</i></p>`,
      qa: `
        <p>
        Diese Chunk-Methode unterstützt die Dateiformate <b>XLSX</b> und <b>CSV/TXT</b>.
      </p>
      <li>
        Wenn eine Datei im <b>XLSX</b>-Format vorliegt, sollte sie zwei Spalten
        ohne Kopfzeilen enthalten: eine für Fragen und die andere für Antworten, wobei die
        Fragenspalte der Antwortspalte vorangeht. Mehrere Blätter sind
        akzeptabel, vorausgesetzt, die Spalten sind richtig strukturiert.
      </li>
      <li>
        Wenn eine Datei im <b>CSV/TXT</b>-Format vorliegt, muss sie UTF-8-kodiert sein und TAB als Trennzeichen verwenden, um Fragen und Antworten zu trennen.
      </li>
      <p>
        <i>
          Textzeilen, die nicht den obigen Regeln folgen, werden ignoriert, und
          jedes Frage-Antwort-Paar wird als eigenständiger Chunk betrachtet.
        </i>
      </p>
        `,
      resume: `<p>Unterstützte Dateiformate sind <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
        </p><p>
        Lebensläufe verschiedener Formen werden analysiert und in strukturierte Daten organisiert, um die Kandidatensuche für Recruiter zu erleichtern.
        </p>
        `,
      table: `<p>Unterstützte Dateiformate sind <b>XLSX</b> und <b>CSV/TXT</b>.</p><p>
        Hier sind einige Voraussetzungen und Tipps:
        <ul>
      <li>Für CSV- oder TXT-Dateien muss das Trennzeichen zwischen den Spalten <em><b>TAB</b></em> sein.</li>
      <li>Die erste Zeile muss Spaltenüberschriften enthalten.</li>
      <li>Spaltenüberschriften müssen aussagekräftige Begriffe sein, um das Verständnis Ihres LLM zu unterstützen.
      Es ist gute Praxis, Synonyme durch einen Schrägstrich <i>'/'</i> zu trennen und Werte unter Verwendung von Klammern aufzuzählen, zum Beispiel: <i>'Gender/Sex (male, female)'</i>.<p>
      Hier sind einige Beispiele für Überschriften:<ol>
          <li>supplier/vendor<b>'TAB'</b>Color (Yellow, Blue, Brown)<b>'TAB'</b>Sex/Gender (male, female)<b>'TAB'</b>size (M, L, XL, XXL)</li>
          </ol>
          </p>
      </li>
      <li>Jede Zeile in der Tabelle wird als Chunk behandelt.</li>
      </ul>`,
      picture: `
      <p>Bilddateien werden unterstützt, Videounterstützung folgt in Kürze.</p><p>
      Diese Methode verwendet ein OCR-Modell, um Texte aus Bildern zu extrahieren.
      </p><p>
      Wenn der vom OCR-Modell extrahierte Text als unzureichend angesehen wird, wird ein bestimmtes visuelles LLM verwendet, um eine Beschreibung des Bildes zu liefern.
      </p>`,
      one: `
      <p>Unterstützte Dateiformate sind <b>DOCX, EXCEL, PDF, TXT</b>.
      </p><p>
      Diese Methode behandelt jedes Dokument in seiner Gesamtheit als einen Chunk.
      </p><p>
      Anwendbar, wenn Sie das LLM das gesamte Dokument zusammenfassen lassen möchten, vorausgesetzt, es kann mit dieser Kontextlänge umgehen.
      </p>`,
      knowledgeGraph: `<p>Unterstützte Dateiformate sind <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>
  
  <p>Dieser Ansatz teilt Dateien mit der 'naiven'/'Allgemeinen' Methode auf. Er teilt ein Dokument in Segmente und kombiniert dann benachbarte Segmente, bis die Token-Anzahl den durch 'Chunk-Token-Anzahl' festgelegten Schwellenwert überschreitet, woraufhin ein Chunk erstellt wird.</p>
  <p>Die Chunks werden dann dem LLM zugeführt, um Entitäten und Beziehungen für einen Wissensgraphen und eine Mind Map zu extrahieren.</p>
  <p>Stellen Sie sicher, dass Sie die <b>Entitätstypen</b> festlegen.</p>`,
      tag: `<p>Eine Wissensdatenbank, die die 'Tag'-Chunk-Methode verwendet, fungiert als Tag-Set. Andere Wissensdatenbanken können es verwenden, um ihre eigenen Chunks zu taggen, und Abfragen an diese Wissensdatenbanken werden ebenfalls mit diesem Tag-Set getaggt.</p>
      <p>Ein Tag-Set wird <b>NICHT</b> direkt in einen Retrieval-Augmented Generation (RAG)-Prozess einbezogen.</p>
      <p>Jeder Chunk in dieser Wissensdatenbank ist ein unabhängiges Beschreibungs-Tag-Paar.</p>
      <p>Zu den unterstützten Dateiformaten gehören <b>XLSX</b> und <b>CSV/TXT</b>:</p>
      <p>Wenn eine Datei im <b>XLSX</b>-Format vorliegt, sollte sie zwei Spalten ohne Überschriften enthalten: eine für Tag-Beschreibungen und die andere für Tag-Namen, wobei die Spalte "Beschreibung" vor der Spalte "Tag" steht. Mehrere Blätter sind zulässig, sofern die Spalten ordnungsgemäß strukturiert sind.</p>
      <p>Wenn eine Datei im <b>CSV/TXT</b>-Format vorliegt, muss sie UTF-8-kodiert sein, wobei TAB als Trennzeichen zum Trennen von Beschreibungen und Tags verwendet wird.</p>
      <p>In einer Tag-Spalte wird das <b>Komma</b> verwendet, um Tags zu trennen.</p>
      <i>Textzeilen, die nicht den obigen Regeln entsprechen, werden ignoriert.</i>
  `,
      useRaptor: 'RAPTOR zur Verbesserung des Abrufs verwenden',
      useRaptorTip:
        'RAPTOR für Multi-Hop-Frage-Antwort-Aufgaben aktivieren.',
      prompt: 'Prompt',
      promptTip:
        'Verwenden Sie den Systemprompt, um die Aufgabe für das LLM zu beschreiben, festzulegen, wie es antworten soll, und andere verschiedene Anforderungen zu skizzieren. Der Systemprompt wird oft in Verbindung mit Schlüsseln (Variablen) verwendet, die als verschiedene Dateninputs für das LLM dienen. Verwenden Sie einen Schrägstrich `/` oder die (x)-Schaltfläche, um die zu verwendenden Schlüssel anzuzeigen.',
      promptMessage: 'Prompt ist erforderlich',
      promptText: `Bitte fassen Sie die folgenden Absätze zusammen. Seien Sie vorsichtig mit den Zahlen, erfinden Sie keine Dinge. Absätze wie folgt:
        {cluster_content}
  Das oben Genannte ist der Inhalt, den Sie zusammenfassen müssen.`,
      maxToken: 'Maximale Token',
      maxTokenTip:
        'Die maximale Anzahl an Token pro generiertem Zusammenfassungs-Chunk.',
      maxTokenMessage: 'Maximale Token sind erforderlich',
      threshold: 'Schwellenwert',
      thresholdTip:
        'In RAPTOR werden Chunks anhand ihrer semantischen Ähnlichkeit gruppiert. Der Schwellenwert-Parameter legt die minimale Ähnlichkeit fest, die erforderlich ist, damit Chunks zusammengefasst werden. Ein höherer Schwellenwert bedeutet weniger Chunks pro Cluster, während ein niedrigerer Wert mehr Chunks pro Cluster zulässt.',
      thresholdMessage: 'Schwellenwert ist erforderlich',
      maxCluster: 'Maximale Cluster',
      maxClusterTip: 'Die maximale Anzahl der zu erstellenden Cluster.',
      maxClusterMessage: 'Maximale Cluster sind erforderlich',
      randomSeed: 'Zufallszahl',
      randomSeedMessage: 'Zufallszahl ist erforderlich',
      entityTypes: 'Entitätstypen',
      vietnamese: 'Vietnamesisch',
      pageRank: 'PageRank',
      pageRankTip:
        'Sie können während des Abrufs bestimmten Wissensdatenbanken eine höhere PageRank-Bewertung zuweisen. Die entsprechende Bewertung wird zu den hybriden Ähnlichkeitswerten der abgerufenen Chunks aus diesen Wissensdatenbanken addiert, wodurch deren Ranking erhöht wird.',
      tagName: 'Tag',
      frequency: 'Häufigkeit',
      searchTags: 'Tags durchsuchen',
      tagCloud: 'Wolke',
      tagTable: 'Tabelle',
      tagSet: 'Tag-Sets',
      tagSetTip: `
       <p> Wählen Sie eine oder mehrere Tag-Wissensdatenbanken aus, um Chunks in Ihrer Wissensdatenbank automatisch zu taggen. </p>
  <p>Die Benutzeranfrage wird ebenfalls automatisch getaggt.</p>
  Diese Auto-Tag-Funktion verbessert den Abruf, indem sie eine weitere Schicht domänenspezifischen Wissens zum vorhandenen Datensatz hinzufügt.
  <p>Unterschied zwischen Auto-Tag und Auto-Schlüsselwort:</p>
  <ul>
    <li>Eine Tag-Wissensdatenbank ist ein benutzerdefiniertes geschlossenes Set, während vom LLM extrahierte Schlüsselwörter als offenes Set betrachtet werden können.</li>
    <li>Sie müssen Tag-Sets in bestimmten Formaten hochladen, bevor Sie die Auto-Tag-Funktion ausführen.</li>
    <li>Die Auto-Schlüsselwort-Funktion ist vom LLM abhängig und verbraucht eine erhebliche Anzahl an Tokens.</li>
  </ul>
        `,
      topnTags: 'Top-N Tags',
      tags: 'Tags',
      addTag: 'Tag hinzufügen',
      useGraphRag: 'Wissensgraph extrahieren',
      useGraphRagTip:
        'Erstellen Sie einen Wissensgraph über Dateiabschnitte der aktuellen Wissensbasis, um die Beantwortung von Fragen mit mehreren Schritten und verschachtelter Logik zu verbessern.',
      graphRagMethod: 'Methode',
      graphRagMethodTip: `Light: (Standard) Verwendet von github.com/HKUDS/LightRAG bereitgestellte Prompts, um Entitäten und Beziehungen zu extrahieren. Diese Option verbraucht weniger Tokens, weniger Speicher und weniger Rechenressourcen.</br>
          General: Verwendet von github.com/microsoft/graphrag bereitgestellte Prompts, um Entitäten und Beziehungen zu extrahieren`,
      resolution: 'Entitätsauflösung',
      resolutionTip: `Ein Entitäts-Deduplizierungsschalter. Wenn aktiviert, wird das LLM ähnliche Entitäten kombinieren - z.B. '2025' und 'das Jahr 2025' oder 'IT' und 'Informationstechnologie' - um einen genaueren Graphen zu konstruieren`,
      community: 'Generierung von Gemeinschaftsberichten',
      communityTip:
        'In einem Wissensgraphen ist eine Gemeinschaft ein Cluster von Entitäten, die durch Beziehungen verbunden sind. Sie können das LLM eine Zusammenfassung für jede Gemeinschaft erstellen lassen, bekannt als Gemeinschaftsbericht. Weitere Informationen finden Sie hier: https://www.microsoft.com/en-us/research/blog/graphrag-improving-global-search-via-dynamic-community-selection/',
    },
    modal: {
      okText: 'Bestätigen',
      cancelText: 'Abbrechen',
    },
    chat: {
      messagePlaceholder: 'Gib hier deine Nachricht ein...',
      exit: 'Beenden',
      multipleModels: 'Mehrere Modelle',
      applyModelConfigs: 'Modellkonfigurationen anwenden',
      conversations: 'Unterhaltungen',
      chatApps: 'Assistenten',
      newConversation: 'Neue Unterhaltung',
      createAssistant: 'Assistent erstellen',
      assistantSetting: 'Assistenteneinstellungen',
      promptEngine: 'Prompt-Engine',
      modelSetting: 'Modelleinstellungen',
      chat: 'Chat-Assistenten',
      newChat: 'Neuer Chat',
      emptyGreeting: 'Wie kann ich Ihnen heute helfen?',
      emptyHint:
        'Fragen Sie alles zu den Dokumenten in Ihren verbundenen Wissensdatenbanken.',
      answerDisclaimer:
        'Antworten werden aus Ihren Dokumenten generiert. Bitte prüfen Sie wichtige Angaben.',
      send: 'Senden',
      sendPlaceholder: 'Nachricht an den Assistenten...',
      chatConfiguration: 'Chat-Konfiguration',
      chatConfigurationDescription:
        'Richte hier einen Chat-Assistenten für deine ausgewählten Datensätze (Wissensdatenbanken) ein! 💕',
      assistantName: 'Assistentenname',
      assistantNameMessage: 'Assistentenname ist erforderlich',
      namePlaceholder: 'z. B. Lebenslauf-Jarvis',
      assistantAvatar: 'Assistentenavatar',
      language: 'Sprache',
      emptyResponse: 'Leere Antwort',
      emptyResponseTip: `Diese Antwort wird verwendet, wenn keine Ergebnisse aus den Wissensdatenbanken abgerufen werden, oder lasse das Feld leer, damit das LLM improvisieren kann, wenn nichts gefunden wird.`,
      emptyResponseMessage: `Die leere Antwort wird ausgelöst, wenn keine relevanten Inhalte aus den Wissensdatenbanken abgerufen werden. Du musst das Feld „Leere Antwort“ löschen, wenn keine Wissensdatenbank ausgewählt ist.`,
      setAnOpener: 'Begrüßung',
      setAnOpenerInitial: `Hallo! Ich bin dein Assistent. Wie kann ich dir helfen?`,
      setAnOpenerTip: 'Lege eine Begrüßungsnachricht für Nutzer fest.',
      knowledgeBases: 'Datensätze',
      knowledgeBasesMessage: 'Bitte auswählen',
      knowledgeBasesTip:
        'Wähle die Datensätze aus, die diesem Chat-Assistenten zugeordnet werden sollen. Leere Wissensdatenbanken erscheinen nicht in der Auswahlliste.',
      system: 'System-Prompt',
      systemInitialValue: `Du bist ein intelligenter Assistent. Bitte fasse die Inhalte der Wissensdatenbank zusammen, um die Frage zu beantworten. Liste die Daten aus der Wissensdatenbank auf und antworte ausführlich. Wenn alle Inhalte der Wissensdatenbank für die Frage irrelevant sind, muss deine Antwort den Satz „Die gesuchte Antwort ist nicht in der Wissensdatenbank enthalten!“ enthalten. Antworten müssen den Chatverlauf berücksichtigen.
      Hier ist die Wissensdatenbank:
      {knowledge}
      Obenstehend ist die Wissensdatenbank.`,
      systemMessage: 'Bitte eingeben!',
      systemTip:
        'Deine Prompts oder Anweisungen für das LLM, einschließlich (aber nicht beschränkt auf) Rolle, gewünschte Länge, Tonfall und Sprache der Antworten. Wenn dein Modell natives Reasoning unterstützt, kannst du //no_thinking zum Prompt hinzufügen, um das Reasoning zu deaktivieren.',
      topN: 'Top N',
      topNTip: `Nicht alle Textabschnitte mit einem Ähnlichkeitswert über dem „Ähnlichkeitsschwellenwert“ werden an das LLM gesendet. Hiermit wählst du die „Top-N“-Abschnitte aus den abgerufenen aus.`,
      variable: 'Variable',
      variableTip: `In Kombination mit den Chat-Assistent-Management-APIs von optimAIse RAG ermöglichen Variablen flexiblere System-Prompt-Strategien. Die definierten Variablen werden vom „System-Prompt“ als Teil der Prompts für das LLM verwendet. {knowledge} ist eine reservierte spezielle Variable, die die aus den angegebenen Wissensdatenbanken abgerufenen Textabschnitte repräsentiert. Alle Variablen müssen im „System-Prompt“ in geschweifte Klammern {} gesetzt werden.`,
      add: 'Hinzufügen',
      key: 'Schlüssel',
      optional: 'Optional',
      operation: 'Operation',
      model: 'Modell',
      modelTip: 'Großes Sprachmodell für Chat',
      modelMessage: 'Bitte auswählen!',
      modelEnabledTools: 'Aktivierte Tools',
      modelEnabledToolsTip:
        'Bitte wähle ein oder mehrere Tools aus, die das Chat-Modell verwenden darf. Hat keine Wirkung bei Modellen ohne Tool-Unterstützung.',
      freedom: 'Kreativität',
      improvise: 'Improvisieren',
      precise: 'Präzise',
      balance: 'Ausgewogen',
      custom: 'Benutzerdefiniert',
      freedomTip: `Eine Abkürzung für die Einstellungen „Temperatur“, „Top P“, „Presence Penalty“ und „Frequency Penalty“, die den Freiheitsgrad des Modells angeben. „Improvisieren“ erzeugt kreativere Antworten, „Präzise“ (Standard) konservativere Antworten, „Ausgewogen“ liegt dazwischen.`,
      temperature: 'Temperatur',
      temperatureMessage: 'Temperatur ist erforderlich',
      temperatureTip: `Dieser Parameter steuert die Zufälligkeit der Modellvorhersagen. Eine niedrigere Temperatur führt zu konservativeren Antworten, eine höhere zu kreativeren und vielfältigeren Antworten.`,
      topP: 'Top P',
      topPMessage: 'Top P ist erforderlich',
      topPTip:
        'Auch bekannt als „Nucleus Sampling“. Dieser Parameter legt einen Schwellenwert fest, um nur die wahrscheinlichsten Wörter auszuwählen und weniger wahrscheinliche auszuschließen.',
      presencePenalty: 'Presence Penalty',
      presencePenaltyMessage: 'Presence Penalty ist erforderlich',
      presencePenaltyTip:
        'Verhindert Wiederholungen, indem Wörter bestraft werden, die bereits in der Unterhaltung erschienen sind.',
      frequencyPenalty: 'Frequency Penalty',
      frequencyPenaltyMessage: 'Frequency Penalty ist erforderlich',
      frequencyPenaltyTip:
        'Ähnlich wie Presence Penalty, reduziert dies die Tendenz des Modells, dieselben Wörter häufig zu wiederholen.',
      maxTokens: 'Max. Token',
      maxTokensMessage: 'Max. Token ist erforderlich',
      maxTokensTip: `Legt die maximale Länge der Modellausgabe in Token fest. Standard ist 512. Wenn deaktiviert, wird die Tokenbegrenzung aufgehoben.`,
      maxTokensInvalidMessage: 'Bitte eine gültige Zahl für Max. Token eingeben.',
      maxTokensMinMessage: 'Max. Token dürfen nicht kleiner als 0 sein.',
      quote: 'Zitat anzeigen',
      quoteTip: 'Gibt an, ob der Originaltext als Referenz angezeigt wird.',
      selfRag: 'Self-RAG',
      overview: 'Chat-ID',
      pv: 'Anzahl der Nachrichten',
      uv: 'Anzahl aktiver Nutzer',
      speed: 'Token-Ausgabegeschwindigkeit',
      tokens: 'Verbrauchte Token',
      round: 'Anzahl der Sitzungsinteraktionen',
      thumbUp: 'Kundenzufriedenheit',
      preview: 'Vorschau',
      embedded: 'Eingebettet',
      serviceApiEndpoint: 'Service-API-Endpunkt',
      apiKey: 'API-SCHLÜSSEL',
      apiReference: 'API-Dokumentation',
      dateRange: 'Datumsbereich:',
      backendServiceApi: 'API-Server',
      createNewKey: 'Neuen Schlüssel erstellen',
      created: 'Erstellt',
      action: 'Aktion',
      embedModalTitle: 'In Webseite einbetten',
      comingSoon: 'Demnächst verfügbar',
      fullScreenTitle: 'Vollständige Einbettung',
      fullScreenDescription:
        'Bette das folgende iframe an der gewünschten Stelle in deine Website ein',
      partialTitle: 'Teilweise Einbettung',
      extensionTitle: 'Chrome-Erweiterung',
      tokenError: 'Bitte zuerst einen API-Schlüssel erstellen.',
      betaError:
        'Bitte fordere zuerst einen optimAIse RAG-API-Schlüssel auf der Seite „Systemeinstellungen“ an.',
      searching: 'Suche...',
      parsing: 'Analysiere',
      uploading: 'Wird hochgeladen',
      uploadFailed: 'Upload fehlgeschlagen',
      regenerate: 'Neu generieren',
      read: 'Inhalt lesen',
      tts: 'Text-zu-Sprache',
      ttsTip:
        'Stelle sicher, dass in den Einstellungen ein TTS-Modell ausgewählt ist, bevor du diese Option aktivierst.',
      relatedQuestion: 'Verwandte Frage',
      answerTitle: 'A',
      multiTurn: 'Multi-Turn-Optimierung',
      multiTurnTip:
        'Optimiert Benutzeranfragen mithilfe des Kontexts aus mehrstufigen Unterhaltungen. Verbraucht zusätzliche LLM-Token.',
      howUseId: 'Wie verwendet man die Chat-ID?',
      description: 'Beschreibung des Assistenten',
      descriptionPlaceholder: 'z. B. Ein Chat-Assistent für Lebensläufe.',
      useKnowledgeGraph: 'Wissensgraph verwenden',
      useKnowledgeGraphTip:
        'Legt fest, ob Wissensgraphen der ausgewählten Wissensdatenbanken für Multi-Hop-Fragen verwendet werden sollen. Dies erhöht die Abrufzeit erheblich.',
      keyword: 'Schlüsselwortanalyse',
      keywordTip: `Verwendet das LLM zur Analyse der Benutzerfrage und extrahiert Schlüsselwörter, die bei der Relevanzberechnung stärker gewichtet werden. Besonders geeignet für lange Anfragen, erhöht jedoch die Antwortzeit.`,
      languageTip:
        'Ermöglicht das Umschreiben von Sätzen in der angegebenen Sprache oder verwendet standardmäßig die letzte Frage.',
      avatarHidden: 'Avatar ausblenden',
      locale: 'Gebietsschema',
      selectLanguage: 'Sprache auswählen',
      reasoning: 'Reasoning',
      reasoningTip: `Legt fest, ob ein Reasoning-Workflow bei der Beantwortung aktiviert wird, wie bei Modellen wie Deepseek-R1 oder OpenAI o1. Dies ermöglicht schrittweises Denken und verbessert die Genauigkeit bei komplexen Fragen.`,
      tavilyApiKeyTip:
        'Wenn hier ein API-Schlüssel korrekt gesetzt ist, werden Tavily-basierte Websuchen zur Ergänzung der Wissensdatenbank verwendet.',
      tavilyApiKeyMessage: 'Bitte Tavily-API-Schlüssel eingeben',
      tavilyApiKeyHelp: 'Wie erhält man ihn?',
      crossLanguage: 'Sprachübergreifende Suche',
      crossLanguageTip: `Wähle eine oder mehrere Sprachen für die sprachübergreifende Suche aus. Wenn keine Sprache gewählt ist, wird mit der Originalanfrage gesucht.`,
      createChat: 'Chat erstellen',
      metadata: 'Metadaten',
      metadataTip:
        'Metadatenfilterung nutzt Attribute wie Tags, Kategorien oder Zugriffsrechte, um relevante Informationen gezielt abzurufen.',
      conditions: 'Bedingungen',
      metadataKeys: 'Filterbare Elemente',
      addCondition: 'Bedingung hinzufügen',
      meta: {
        disabled: 'Deaktiviert',
        auto: 'Automatisch',
        manual: 'Manuell',
        semi_auto: 'Halbautomatisch',
      },
      cancel: 'Abbrechen',
      chatSetting: 'Chat-Einstellungen',
      tocEnhance: 'Inhaltsverzeichnis-Optimierung',
      tocEnhanceTip: `Während der Dokumentanalyse wurden Inhaltsverzeichnis-Informationen generiert. Dadurch kann das Modell relevante TOC-Einträge zurückgeben und diese zur Gewichtung bei der Sortierung verwenden.`,
    },
    setting: {
      deleteModel: 'Modell löschen',
      modelEmptyTip:
        'Keine Modelle verfügbar.<br>Bitte fügen Sie Modelle über das Panel auf der rechten Seite hinzu.',
      sourceEmptyTip: 'Noch keine Datenquellen hinzugefügt. Wählen Sie unten eine aus, um sie zu verbinden.',
      seconds: 'Sekunden',
      minutes: 'Minuten',
      edit: 'Bearbeiten',
      cropTip:
        'Ziehen Sie den Auswahlbereich, um den Bildausschnitt festzulegen, und scrollen Sie zum Vergrößern/Verkleinern',
      cropImage: 'Bild zuschneiden',
      selectModelPlaceholder: 'Modell auswählen',
      configureModelTitle: 'Modell konfigurieren',
      confluenceIsCloudTip:
        'Aktivieren Sie dies, wenn es sich um eine Confluence-Cloud-Instanz handelt; deaktivieren Sie es für Confluence Server/Data Center',
      confluenceWikiBaseUrlTip:
        'Die Basis-URL Ihrer Confluence-Instanz (z. B. https://your-domain.atlassian.net/wiki)',
      confluenceSpaceKeyTip:
        'Optional: Geben Sie einen Space-Key an, um die Synchronisierung auf einen bestimmten Bereich zu beschränken. Leer lassen, um alle zugänglichen Spaces zu synchronisieren. Mehrere Spaces mit Kommas trennen (z. B. DEV,DOCS,HR)',
      s3PrefixTip: `Geben Sie den Ordnerpfad innerhalb Ihres S3-Buckets an, aus dem Dateien abgerufen werden sollen. Beispiel: general/v2/`,
      S3CompatibleEndpointUrlTip: `Erforderlich für S3-kompatible Storage-Boxen. Geben Sie die S3-kompatible Endpoint-URL an. Beispiel: https://fsn1.your-objectstorage.com`,
      S3CompatibleAddressingStyleTip: `Erforderlich für S3-kompatible Storage-Boxen. Geben Sie den S3-kompatiblen Adressierungsstil an. Beispiel: Virtual Hosted Style`,
      addDataSourceModalTital: 'Erstellen Sie Ihren {{name}}-Connector',
      deleteSourceModalTitle: 'Datenquelle löschen',
      deleteSourceModalContent: ` <p>Möchten Sie diese Verknüpfung zur Datenquelle wirklich löschen?</p>`,
      deleteSourceModalConfirmText: 'Bestätigen',
      errorMsg: 'Fehlermeldung',
      newDocs: 'Neue Dokumente',
      timeStarted: 'Startzeit',
      log: 'Protokoll',
      confluenceDescription:
        'Integrieren Sie Ihren Confluence-Arbeitsbereich, um Dokumentationen zu durchsuchen.',
      s3Description:
        'Verbinden Sie Ihren AWS-S3-Bucket, um gespeicherte Dateien zu importieren und zu synchronisieren.',
      discordDescription:
        'Verknüpfen Sie Ihren Discord-Server, um auf Chatdaten zuzugreifen und diese zu analysieren.',
      notionDescription:
        'Synchronisieren Sie Seiten und Datenbanken aus Notion für den Wissensabruf.',
      google_driveDescription:
        'Verbinden Sie Google Drive über OAuth und synchronisieren Sie bestimmte Ordner oder Laufwerke.',
      gmailDescription: 'Verbinden Sie Ihr Gmail über OAuth, um E-Mails zu synchronisieren.',
      webdavDescription: 'Verbinden Sie WebDAV-Server, um Dateien zu synchronisieren.',
      webdavRemotePathTip:
        'Optional: Geben Sie einen Ordnerpfad auf dem WebDAV-Server an (z. B. /Documents). Leer lassen, um vom Stammverzeichnis zu synchronisieren.',
      ftpDescription: 'Verbinden Sie FTP- oder FTPS-Server, um Dateien zu synchronisieren.',
      ftpPortTip: 'Standardmäßig 21. Verwenden Sie einen abweichenden Port, falls Ihr Server entsprechend konfiguriert ist.',
      ftpRemotePathTip:
        'Optional: Geben Sie einen Ordnerpfad auf dem FTP-Server an (z. B. /uploads). Leer lassen, um vom Stammverzeichnis zu synchronisieren.',
      ftpUseTlsTip:
        'Aktivieren Sie diese Option für explizites FTPS (AUTH TLS). Empfohlen für jeden über das Internet erreichbaren Server.',
      ftpPassiveTip:
        'Passiv-Modus (PASV) verwenden. Empfohlen, wenn der Client hinter NAT oder einer Firewall steht.',
      google_driveTokenTip:
        'Laden Sie das OAuth-Token-JSON hoch, das mit dem OAuth-Helper oder der Google Cloud Console erstellt wurde. Alternativ können Sie ein client_secret-JSON einer „installed“- oder „web“-Anwendung hochladen. Beim ersten Sync öffnet sich ein Browserfenster zur OAuth-Autorisierung. Enthält das JSON bereits ein Refresh-Token, wird dieses automatisch wiederverwendet.',
      google_drivePrimaryAdminTip:
        'E-Mail-Adresse mit Zugriff auf die zu synchronisierenden Drive-Inhalte.',
      google_driveMyDriveEmailsTip:
        'Kommagetrennte E-Mail-Adressen, deren „Mein Drive“-Inhalte indexiert werden sollen (inkl. primärem Admin).',
      google_driveSharedFoldersTip:
        'Kommagetrennte Google-Drive-Ordnerlinks, die gecrawlt werden sollen.',
      gmailPrimaryAdminTip:
        'Primäre Admin-E-Mail mit Gmail-/Workspace-Zugriff; dient zur Auflistung der Domain-Benutzer und als Standard-Sync-Konto.',
      gmailTokenTip:
        'Laden Sie das OAuth-JSON aus der Google Console hoch. Enthält es nur Client-Zugangsdaten, führen Sie einmal die browserbasierte Verifizierung durch, um langlebige Refresh-Tokens zu erzeugen.',
      dropboxDescription:
        'Verbinden Sie Dropbox, um Dateien und Ordner eines ausgewählten Kontos zu synchronisieren.',
      dropboxAccessTokenTip:
        'Erstellen Sie ein langlebiges Zugriffstoken in der Dropbox App Console mit den Berechtigungen files.metadata.read, files.content.read und sharing.read.',
      moodleDescription:
        'Verbinden Sie Ihr Moodle-LMS, um Kursinhalte, Foren und Ressourcen zu synchronisieren.',
      moodleUrlTip:
        'Die Basis-URL Ihrer Moodle-Instanz (z. B. https://moodle.university.edu). /webservice oder /login nicht einschließen.',
      moodleTokenTip:
        'Erstellen Sie in Moodle ein Webservice-Token: Website-Administration → Server → Webservices → Tokens verwalten. Der Benutzer muss in den zu synchronisierenden Kursen eingeschrieben sein.',
      jiraDescription:
        'Verbinden Sie Ihren Jira-Arbeitsbereich, um Tickets, Kommentare und Anhänge zu synchronisieren.',
      jiraBaseUrlTip:
        'Basis-URL Ihrer Jira-Seite (z. B. https://your-domain.atlassian.net).',
      jiraProjectKeyTip:
        'Optional: Synchronisierung auf einen einzelnen Projekt-Key beschränken (z. B. ENG).',
      jiraJqlTip:
        'Optionaler JQL-Filter. Leer lassen, um Projekt-/Zeitfilter zu verwenden.',
      jiraBatchSizeTip:
        'Maximale Anzahl von Issues, die pro Batch von Jira abgerufen werden.',
      jiraCommentsTip:
        'Jira-Kommentare in das generierte Markdown-Dokument einbeziehen.',
      jiraAttachmentsTip:
        'Anhänge während der Synchronisierung als separate Dokumente herunterladen.',
      jiraAttachmentSizeTip:
        'Anhänge, die größer als diese Byte-Anzahl sind, werden übersprungen.',
      jiraLabelsTip:
        'Labels, die beim Indexieren übersprungen werden sollen (kommagetrennt).',
      jiraBlacklistTip:
        'Kommentare, deren Autor-E-Mail diesen Einträgen entspricht, werden ignoriert.',
      jiraScopedTokenTip:
        'Aktivieren Sie dies bei Verwendung von Scoped-Atlassian-Tokens (api.atlassian.com).',
      jiraEmailTip: 'E-Mail-Adresse des Jira-Kontos/API-Tokens.',
      jiraTokenTip:
        'API-Token, generiert unter https://id.atlassian.com/manage-profile/security/api-tokens.',
      jiraPasswordTip:
        'Optionales Passwort für Jira Server/Data-Center-Umgebungen.',
      availableSourcesDescription: 'Wählen Sie eine Datenquelle zum Hinzufügen aus',
      availableSources: 'Verfügbare Quellen',
      datasourceDescription: 'Verwalten Sie Ihre Datenquellen und Verbindungen',
      save: 'Speichern',
      search: 'Suchen',
      availableModels: 'Verfügbare Modelle',
      profile: 'Profil',
      avatar: 'Avatar',
      avatarTip: 'Dies wird in Ihrem Profil angezeigt.',
      profileDescription: 'Aktualisieren Sie hier Ihr Foto und Ihre persönlichen Daten.',
      maxTokens: 'Max. Token',
      maxTokensMessage: 'Max. Token ist erforderlich',
      maxTokensTip: `Legt die maximale Länge der Modellantwort in Tokens fest. Standard ist 512. Wenn deaktiviert, wird das Token-Limit aufgehoben und das Modell bestimmt die Länge der Antwort selbst.`,
      maxTokensInvalidMessage: 'Bitte geben Sie eine gültige Zahl für Max. Token ein.',
      maxTokensMinMessage: 'Max. Token darf nicht kleiner als 0 sein.',
      password: 'Passwort',
      passwordDescription:
        'Bitte geben Sie Ihr aktuelles Passwort ein, um Ihr Passwort zu ändern.',
      model: 'Modellanbieter',
      systemModelDescription: 'Bitte schließen Sie diese Einstellungen ab, bevor Sie beginnen',
      dataSources: 'Datenquellen',
      team: 'Team',
      system: 'System',
      logout: 'Abmelden',
      api: 'API',
      enterpriseUsers: 'Benutzerverwaltung',
      username: 'Name',
      usernameMessage: 'Bitte geben Sie Ihren Benutzernamen ein!',
      photo: 'Ihr Foto',
      photoDescription: 'Dies wird in Ihrem Profil angezeigt.',
      colorSchema: 'Farbschema',
      colorSchemaMessage: 'Bitte wählen Sie Ihr Farbschema!',
      colorSchemaPlaceholder: 'Farbschema auswählen',
      bright: 'Hell',
      dark: 'Dunkel',
      timezone: 'Zeitzone',
      timezoneMessage: 'Bitte geben Sie Ihre Zeitzone ein!',
      timezonePlaceholder: 'Zeitzone auswählen',
      email: 'E-Mail',
      emailDescription: 'Nach der Registrierung kann die E-Mail-Adresse nicht geändert werden.',
      currentPassword: 'Aktuelles Passwort',
      currentPasswordMessage: 'Bitte geben Sie Ihr Passwort ein!',
      newPassword: 'Neues Passwort',
      changePassword: 'Passwort ändern',
      newPasswordMessage: 'Bitte geben Sie Ihr Passwort ein!',
      newPasswordDescription:
        'Ihr neues Passwort muss länger als 8 Zeichen sein.',
      confirmPassword: 'Neues Passwort bestätigen',
      confirmPasswordMessage: 'Bitte bestätigen Sie Ihr Passwort!',
      confirmPasswordNonMatchMessage:
        'Die eingegebenen neuen Passwörter stimmen nicht überein!',
      cancel: 'Abbrechen',
      addedModels: 'Hinzugefügte Modelle',
      modelsToBeAdded: 'Hinzuzufügende Modelle',
      addTheModel: 'Hinzufügen',
      apiKey: 'API-Schlüssel',
      apiKeyMessage: 'Bitte geben Sie den API-Schlüssel ein',
      apiKeyTip:
        'Der API-Schlüssel kann durch Registrierung beim jeweiligen LLM-Anbieter erhalten werden.',
      showMoreModels: 'Modelle anzeigen',
      hideModels: 'Modelle ausblenden',
      baseUrl: 'Base-URL',
      baseUrlTip:
        'Wenn Ihr API-Schlüssel von OpenAI stammt, können Sie dieses Feld ignorieren. Andere Anbieter stellen diese Base-URL zusammen mit dem API-Schlüssel bereit.',
      tongyiBaseUrlTip:
        'Für chinesische Nutzer nicht erforderlich oder https://dashscope.aliyuncs.com/compatible-mode/v1 verwenden. Für internationale Nutzer: https://dashscope-intl.aliyuncs.com/compatible-mode/v1',
      tongyiBaseUrlPlaceholder: '(Nur für internationale Nutzer, siehe Hinweis)',
      minimaxBaseUrlTip:
        'Nur für internationale Nutzer: https://api.minimax.io/v1 verwenden',
      minimaxBaseUrlPlaceholder:
        '(Nur für internationale Nutzer, https://api.minimax.io/v1 eintragen)',
      modify: 'Ändern',
      systemModelSettings: 'Standardmodelle festlegen',
      chatModel: 'LLM',
      chatModelTip: 'Das Standard-LLM für jede neu erstellte Wissensbasis.',
      embeddingModel: 'Embedding',
      embeddingModelTip:
        'Das Standard-Embedding-Modell für jede neu erstellte Wissensbasis.',
      img2txtModel: 'VLM',
      img2txtModelTip:
        'Das Standard-VLM für jede neu erstellte Wissensbasis. Beschreibt Bilder oder Videos.',
      sequence2txtModel: 'ASR',
      sequence2txtModelTip:
        'Das Standard-ASR-Modell für jede neu erstellte Wissensbasis zur Umwandlung von Sprache in Text.',
      rerankModel: 'Re-Rank',
      rerankModelTip:
        'Standard-Re-Rank-Modell für das erneute Ranking von Chunks.',
      ttsModel: 'TTS',
      ttsModelTip:
        'Das Standard-Text-zu-Sprache-Modell.',
      workspace: 'Arbeitsbereich',
      upgrade: 'Upgrade',
      addLlmTitle: 'LLM hinzufügen',
      editLlmTitle: 'Modell {{name}} bearbeiten',
      editModel: 'Modell bearbeiten',
      modelName: 'Modellname',
      modelID: 'Modell-ID',
      modelUid: 'Modell-UID',
      modelNameMessage: 'Bitte geben Sie Ihren Modellnamen ein!',
      modelType: 'Modelltyp',
      modelTypeMessage: 'Bitte geben Sie Ihren Modelltyp ein!',
      addLlmBaseUrl: 'Base-URL',
      baseUrlNameMessage: 'Bitte geben Sie Ihre Base-URL ein!',
      vision: 'Unterstützt Vision?',
      ollamaLink: 'So integrieren Sie {{name}}',
      FishAudioLink: 'So verwenden Sie FishAudio',
      TencentCloudLink: 'So verwenden Sie TencentCloud ASR',
      volcModelNameMessage: 'Bitte geben Sie Ihren Modellnamen ein!',
      addEndpointID: 'Endpoint-ID des Modells',
      endpointIDMessage: 'Bitte geben Sie die Endpoint-ID des Modells ein',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Bitte geben Sie Ihren ARK_API_KEY ein',
      bedrockModelNameMessage: 'Bitte geben Sie Ihren Modellnamen ein!',
      addBedrockEngineAK: 'ACCESS KEY',
      bedrockAKMessage: 'Bitte geben Sie Ihren ACCESS KEY ein',
      addBedrockSK: 'SECRET KEY',
      bedrockSKMessage: 'Bitte geben Sie Ihren SECRET KEY ein',
      bedrockRegion: 'AWS-Region',
      bedrockRegionMessage: 'Bitte auswählen!',
      'us-east-2': 'US East (Ohio)',
      'us-east-1': 'US East (N. Virginia)',
      'us-west-1': 'US West (N. California)',
      'us-west-2': 'US West (Oregon)',
      'af-south-1': 'Afrika (Kapstadt)',
      'ap-east-1': 'Asien-Pazifik (Hongkong)',
      'ap-south-2': 'Asien-Pazifik (Hyderabad)',
      'ap-southeast-3': 'Asien-Pazifik (Jakarta)',
      'ap-southeast-5': 'Asien-Pazifik (Malaysia)',
      'ap-southeast-4': 'Asien-Pazifik (Melbourne)',
      'ap-south-1': 'Asien-Pazifik (Mumbai)',
      'ap-northeast-3': 'Asien-Pazifik (Osaka)',
      'ap-northeast-2': 'Asien-Pazifik (Seoul)',
      'ap-southeast-1': 'Asien-Pazifik (Singapur)',
      'ap-southeast-2': 'Asien-Pazifik (Sydney)',
      'ap-east-2': 'Asien-Pazifik (Taipeh)',
      'ap-southeast-7': 'Asien-Pazifik (Thailand)',
      'ap-northeast-1': 'Asien-Pazifik (Tokio)',
      'ca-central-1': 'Kanada (Zentral)',
      'ca-west-1': 'Kanada West (Calgary)',
      'eu-central-1': 'Europa (Frankfurt)',
      'eu-west-1': 'Europa (Irland)',
      'eu-west-2': 'Europa (London)',
      'eu-south-1': 'Europa (Mailand)',
      'eu-west-3': 'Europa (Paris)',
      'eu-south-2': 'Europa (Spanien)',
      'eu-north-1': 'Europa (Stockholm)',
      'eu-central-2': 'Europa (Zürich)',
      'il-central-1': 'Israel (Tel Aviv)',
      'mx-central-1': 'Mexiko (Zentral)',
      'me-south-1': 'Naher Osten (Bahrain)',
      'me-central-1': 'Naher Osten (VAE)',
      'sa-east-1': 'Südamerika (São Paulo)',
      'us-gov-east-1': 'AWS GovCloud (US-East)',
      'us-gov-west-1': 'AWS GovCloud (US-West)',
      addHunyuanSID: 'Hunyuan Secret ID',
      HunyuanSIDMessage: 'Bitte geben Sie Ihre Secret ID ein',
      addHunyuanSK: 'Hunyuan Secret Key',
      HunyuanSKMessage: 'Bitte geben Sie Ihren Secret Key ein',
      addTencentCloudSID: 'TencentCloud Secret ID',
      TencentCloudSIDMessage: 'Bitte geben Sie Ihre Secret ID ein',
      addTencentCloudSK: 'TencentCloud Secret Key',
      TencentCloudSKMessage: 'Bitte geben Sie Ihren Secret Key ein',
      SparkModelNameMessage: 'Bitte Spark-Modell auswählen',
      addSparkAPIPassword: 'Spark API-Passwort',
      SparkAPIPasswordMessage: 'Bitte geben Sie Ihr API-Passwort ein',
      addSparkAPPID: 'Spark APP-ID',
      SparkAPPIDMessage: 'Bitte geben Sie Ihre APP-ID ein',
      addSparkAPISecret: 'Spark API-Secret',
      SparkAPISecretMessage: 'Bitte geben Sie Ihr API-Secret ein',
      addSparkAPIKey: 'Spark API-Key',
      SparkAPIKeyMessage: 'Bitte geben Sie Ihren API-Key ein',
      yiyanModelNameMessage: 'Bitte geben Sie den Modellnamen ein',
      addyiyanAK: 'Yiyan API-Key',
      yiyanAKMessage: 'Bitte geben Sie Ihren API-Key ein',
      addyiyanSK: 'Yiyan Secret Key',
      yiyanSKMessage: 'Bitte geben Sie Ihren Secret Key ein',
      FishAudioModelNameMessage:
        'Bitte geben Sie Ihrem Sprachsynthese-Modell einen Namen',
      addFishAudioAK: 'FishAudio API-Key',
      addFishAudioAKMessage: 'Bitte geben Sie Ihren API-Key ein',
      addFishAudioRefID: 'FishAudio Referenz-ID',
      addFishAudioRefIDMessage:
        'Bitte geben Sie die Referenz-ID ein (leer lassen, um das Standardmodell zu verwenden).',
      GoogleModelIDMessage: 'Bitte geben Sie Ihre Modell-ID ein!',
      addGoogleProjectID: 'Projekt-ID',
      GoogleProjectIDMessage: 'Bitte geben Sie Ihre Projekt-ID ein',
      addGoogleServiceAccountKey:
        'Service-Account-Schlüssel (leer lassen bei Application Default Credentials)',
      GoogleServiceAccountKeyMessage:
        'Bitte geben Sie den Google-Cloud-Service-Account-Schlüssel im Base64-Format ein',
      addGoogleRegion: 'Google-Cloud-Region',
      GoogleRegionMessage: 'Bitte geben Sie die Google-Cloud-Region ein',
      modelProvidersWarn:
        'Bitte fügen Sie zuerst sowohl ein Embedding-Modell als auch ein LLM unter <b>Einstellungen > Modellanbieter</b> hinzu und legen Sie diese anschließend unter „Standardmodelle festlegen“ fest.',
      apiVersion: 'API-Version',
      apiVersionMessage: 'Bitte geben Sie die API-Version ein',
      add: 'Hinzufügen',
      updateDate: 'Datum',
      role: 'Status',
      invite: 'Mitglied einladen',
      agree: 'Annehmen',
      refuse: 'Ablehnen',
      teamMembers: 'Teammitglieder',
      joinedTeams: 'Beigetretene Teams',
      sureDelete: 'Möchten Sie dieses Mitglied wirklich entfernen?',
      quit: 'Verlassen',
      sureQuit: 'Möchten Sie das beigetretene Team wirklich verlassen?',
      secretKey: 'Geheimer Schlüssel',
      publicKey: 'Öffentlicher Schlüssel',
      secretKeyMessage: 'Bitte geben Sie den geheimen Schlüssel ein',
      publicKeyMessage: 'Bitte geben Sie den öffentlichen Schlüssel ein',
      hostMessage: 'Bitte geben Sie den Host ein',
      configuration: 'Konfiguration',
      langfuseDescription:
        'Traces, Auswertungen, Prompt-Management und Metriken zur Analyse und Verbesserung Ihrer LLM-Anwendung.',
      viewLangfuseSDocumentation: 'Langfuse-Dokumentation ansehen',
      view: 'Ansehen',
      modelsToBeAddedTooltip:
        'Wenn Ihr Modellanbieter nicht gelistet ist, aber „OpenAI-kompatibel“ ist, wählen Sie die Karte „OpenAI-API-kompatibel“, um die entsprechenden Modelle hinzuzufügen.',
      mcp: 'MCP',
      llmSettingsAdminNotice: 'Die Provider und APIKeys werden von allen Benutzern in diesem Deployment genutzt!',
      addLlm: 'Provider für LLM-Hosting hinzufügen',
      addSingleLlm: 'On-Premise Modell hinzufügen',
      factory: 'Provider',
      addSingleLlmTitle: 'Hinzufügen eines On-Premise gehosteten Modells',
      apiKeyOptional: 'API-Schlüssel (optional)',
      noLlmConfigured: 'Bisher wurde noch kein LLM oder Provider konfiguriert',
      removeFactory: 'Provider entfernen',
      mineru: {
        modelNameRequired: 'Modellname ist erforderlich',
        apiserver: 'MinerU API-Server-Konfiguration',
        outputDir: 'MinerU-Ausgabeverzeichnis',
        backend: 'MinerU-Verarbeitungs-Backend-Typ',
        serverUrl: 'MinerU-Server-URL',
        deleteOutput: 'Ausgabedateien nach der Verarbeitung löschen',
        selectBackend: 'Verarbeitungs-Backend auswählen',
        backendOptions: {
          pipeline: 'Standard-Pipeline-Verarbeitung',
          vlmTransformers: 'Vision-Language-Modell mit Transformers',
          vlmVllmEngine: 'Vision-Language-Modell mit vLLM-Engine',
          vlmHttpClient: 'Vision-Language-Modell über HTTP-Client',
        },
      },
    },
    message: {
      registered: 'Registriert!',
      logout: 'Abgemeldet',
      logged: 'Angemeldet!',
      pleaseSelectChunk: 'Bitte wählen Sie einen Chunk aus!',
      modified: 'Geändert',
      created: 'Erstellt',
      deleted: 'Gelöscht',
      renamed: 'Umbenannt',
      operated: 'Ausgeführt',
      updated: 'Aktualisiert',
      uploaded: 'Hochgeladen',
      200: 'Der Server gibt die angeforderten Daten erfolgreich zurück.',
      201: 'Daten erfolgreich erstellt oder geändert.',
      202: 'Eine Anfrage wurde im Hintergrund in die Warteschlange gestellt (asynchrone Aufgabe).',
      204: 'Daten erfolgreich gelöscht.',
      400: 'Bei der gestellten Anfrage ist ein Fehler aufgetreten, und der Server hat keine Daten erstellt oder geändert.',
      401: 'Bitte melden Sie sich erneut an.',
      403: 'Der Benutzer ist autorisiert, aber der Zugriff ist verboten.',
      404: 'Die Anfrage wurde für einen nicht existierenden Datensatz gestellt, und der Server hat den Vorgang nicht ausgeführt.',
      406: 'Das angeforderte Format ist nicht verfügbar.',
      410: 'Die angeforderte Ressource wurde dauerhaft gelöscht und wird nicht mehr verfügbar sein.',
      413: 'Die Gesamtgröße der auf einmal hochgeladenen Dateien ist zu groß.',
      422: 'Beim Erstellen eines Objekts ist ein Validierungsfehler aufgetreten.',
      500: 'Ein Serverfehler ist aufgetreten, bitte überprüfen Sie den Server.',
      502: 'Gateway-Fehler.',
      503: 'Der Dienst ist nicht verfügbar und der Server ist vorübergehend überlastet oder wird gewartet.',
      504: 'Gateway-Timeout.',
      requestError: 'Anfragefehler',
      networkAnomalyDescription:
        'Es liegt eine Anomalie in Ihrem Netzwerk vor und Sie können keine Verbindung zum Server herstellen.',
      networkAnomaly: 'Netzwerkanomalie',
      hint: 'Hinweis',
    },
    fileManager: {
      name: 'Name',
      uploadDate: 'Hochladedatum',
      knowledgeBase: 'Wissensdatenbank',
      size: 'Größe',
      action: 'Aktion',
      addToKnowledge: 'Mit Wissensdatenbank verknüpfen',
      pleaseSelect: 'Bitte auswählen',
      newFolder: 'Neuer Ordner',
      file: 'Datei',
      uploadFile: 'Datei hochladen',
      parseOnCreation: 'Bei Erstellung analysieren',
      directory: 'Verzeichnis',
      uploadTitle: 'Ziehen Sie Ihre Datei hierher, um sie hochzuladen',
      uploadDescription:
        'optimAIse RAG unterstützt das Hochladen von Dateien einzeln oder in Batches. Die maximale Dateigröße pro Upload beträgt 1 GB, mit einem Batch-Upload-Limit von 32 Dateien. Es gibt keine Begrenzung der Gesamtanzahl an Dateien pro Konto.',
      local: 'Lokale Uploads',
      s3: 'S3-Uploads',
      preview: 'Vorschau',
      fileError: 'Dateifehler',
      uploadLimit:
        'Jede Datei darf 10MB nicht überschreiten, und die Gesamtzahl der Dateien darf 128 nicht überschreiten.', //??????
      destinationFolder: 'Zielordner',
    },
    empty: {
      noMCP: 'Keine MCP-Server verfügbar',
      agentTitle: 'Noch keine Agenten-App erstellt',
      notFoundAgent: 'Agenten-App nicht gefunden',
      datasetTitle: 'Noch kein Datensatz erstellt',
      notFoundDataset: 'Datensatz nicht gefunden',
      chatTitle: 'Noch keine Chat-App erstellt',
      notFoundChat: 'Chat-App nicht gefunden',
      noChatAssigned:
        'Ihnen wurde noch kein Assistent zugewiesen. Bitte wenden Sie sich an die Administration.',
      searchTitle: 'Noch keine Such-App erstellt',
      notFoundSearch: 'Such-App nicht gefunden',
      memoryTitle: 'Noch kein Speicher erstellt',
      notFoundMemory: 'Speicher nicht gefunden',
      addNow: 'Jetzt hinzufügen',
    },
    pagination: {
      total: 'Gesamt {{total}}',
      page: '{{page}} / Seite',
    },
    search: {
      searchApps: 'Such-Apps',
      createSearch: 'Suche erstellen',
      searchGreeting: 'Wie kann ich dir heute helfen?',
      profile: 'Profil ausblenden',
      locale: 'Gebietsschema',
      embedCode: 'Einbettungscode',
      id: 'ID',
      copySuccess: 'Erfolgreich kopiert',
      welcomeBack: 'Willkommen zurück',
      searchSettings: 'Sucheinstellungen',
      name: 'Name',
      avatar: 'Avatar',
      description: 'Beschreibung',
      datasets: 'Datensätze',
      rerankModel: 'Rerank-Modell',
      AISummary: 'KI-Zusammenfassung',
      enableWebSearch: 'Websuche aktivieren',
      enableRelatedSearch: 'Verwandte Suche aktivieren',
      showQueryMindmap: 'Abfrage-Mindmap anzeigen',
      embedApp: 'App einbetten',
      relatedSearch: 'Verwandte Suche',
      descriptionValue: 'Du bist ein intelligenter Assistent.',
      okText: 'Speichern',
      cancelText: 'Abbrechen',
      chooseDataset: 'Bitte zuerst einen Datensatz auswählen',
    },
    flow: {
      autoPlay: 'Audio automatisch abspielen',
      downloadFileTypeTip: 'Der Dateityp für den Download',
      downloadFileType: 'Download-Dateityp',
      formatTypeError: 'Format- oder Typfehler',
      variableNameMessage:
        'Variablennamen dürfen nur Buchstaben, Zahlen und Unterstriche enthalten',
      variableDescription: 'Variablenbeschreibung',
      defaultValue: 'Standardwert',
      conversationVariable: 'Konversationsvariable',
      recommended: 'Empfohlen',
      customerSupport: 'Kundensupport',
      marketing: 'Marketing',
      consumerApp: 'Endnutzer-App',
      other: 'Sonstiges',
      ingestionPipeline: 'Ingestions-Pipeline',
      agents: 'Agenten',
      days: 'Tage',
      beginInput: 'Eingabe starten',
      ref: 'Variable',
      stockCode: 'Aktiencode',
      apiKeyPlaceholder:
        'DEIN_API_KEY (erhalten über https://serpapi.com/manage-api-key)',
      flowStart: 'Start',
      flowNum: 'N',
      test: 'Test',
      extractDepth: 'Extraktionstiefe',
      format: 'Format',
      basic: 'Einfach',
      advanced: 'Erweitert',
      general: 'Allgemein',
      searchDepth: 'Suchtiefe',
      tavilyTopic: 'Tavily-Thema',
      maxResults: 'Max. Ergebnisse',
      includeAnswer: 'Antwort einbeziehen',
      includeRawContent: 'Rohinhalt einbeziehen',
      includeImages: 'Bilder einbeziehen',
      includeImageDescriptions: 'Bildbeschreibungen einbeziehen',
      includeDomains: 'Domains einbeziehen',
      ExcludeDomains: 'Domains ausschließen',
      Days: 'Tage',
      comma: 'Komma',
      semicolon: 'Semikolon',
      period: 'Punkt',
      lineBreak: 'Zeilenumbruch',
      tab: 'Tabulator',
      space: 'Leerzeichen',
      delimiters: 'Trennzeichen',
      merge: 'Zusammenführen',
      split: 'Trennen',
      script: 'Skript',
      iterationItemDescription:
        'Repräsentiert das aktuelle Element in der Iteration, das in nachfolgenden Schritten referenziert und bearbeitet werden kann.',
      guidingQuestion: 'Leitfrage',
      onFailure: 'Bei Fehler',
      userPromptDefaultValue:
        'Dies ist die Anweisung, die du an den Agenten senden sollst.',
      search: 'Suche',
      communication: 'Kommunikation',
      developer: 'Entwickler',
      typeCommandOrsearch: 'Befehl eingeben oder suchen...',
      builtIn: 'Integriert',
      ExceptionDefaultValue: 'Standardwert bei Ausnahme',
      exceptionMethod: 'Ausnahmemethode',
      maxRounds: 'Max. Reflexionsrunden',
      delayEfterError: 'Verzögerung nach Fehler',
      maxRetries: 'Max. Wiederholungen',
      advancedSettings: 'Erweiterte Einstellungen',
      addTools: 'Tools hinzufügen',
      sysPromptDefaultValue: `
      <role>
        Du bist ein hilfreicher Assistent, spezialisiert auf problemlösendes Arbeiten für den Nutzer.
        Wenn ein spezifischer Fachbereich angegeben ist, passe dein Fachwissen entsprechend an,
        andernfalls agiere als Generalist.
      </role>
      <instructions>
        1. Verstehe die Anfrage des Nutzers.
        2. Zerlege sie in logische Teilaufgaben.
        3. Führe jede Teilaufgabe schrittweise und nachvollziehbar aus.
        4. Überprüfe Genauigkeit und Konsistenz.
        5. Fasse das Endergebnis klar zusammen.
      </instructions>`,
      singleLineText: 'Einzeiliger Text',
      multimodalModels: 'Multimodale Modelle',
      textOnlyModels: 'Nur-Text-Modelle',
      allModels: 'Alle Modelle',
      codeExecDescription: 'Schreibe deine eigene Python- oder JavaScript-Logik.',
      stringTransformDescription:
        'Modifiziert Textinhalte. Unterstützt derzeit: Text trennen oder zusammenfügen.',
      foundation: 'Grundlage',
      tools: 'Tools',
      dataManipulation: 'Datenmanipulation',
      flow: 'Flow',
      dialog: 'Dialog',
      cite: 'Zitieren',
      citeTip: 'Zitat-Hinweis',
      name: 'Name',
      nameMessage: 'Bitte Namen eingeben',
      description: 'Beschreibung',
      descriptionMessage: 'Dies ist ein Agent für eine bestimmte Aufgabe.',
      examples: 'Beispiele',
      to: 'An',
      msg: 'Nachrichten',
      msgTip:
        'Gibt den Variableninhalt der vorherigen Komponente oder selbst eingegebenen Text aus.',
      messagePlaceholder:
        `Bitte Nachricht eingeben, verwende '/' zum schnellen Einfügen von Variablen.`,
      messageMsg: 'Bitte Nachricht eingeben oder dieses Feld löschen.',
      addField: 'Option hinzufügen',
      addMessage: 'Nachricht hinzufügen',
      loop: 'Schleife',
      loopDescription:
        'Legt die maximale Anzahl an Schleifendurchläufen fest. Wird der Wert überschritten, kann die Komponente die Aufgabe nicht abschließen.',
      exitLoop: 'Schleife verlassen',
      exitLoopDescription:
        `Entspricht "break". Dieser Knoten hat keine Konfiguration. Sobald er erreicht wird, endet die Schleife.`,
      loopVariables: 'Schleifenvariablen',
      maximumLoopCount: 'Maximale Schleifenanzahl',
      loopTerminationCondition: 'Abbruchbedingung der Schleife',
      yes: 'Ja',
      no: 'Nein',
      key: 'Schlüssel',
      componentId: 'Komponenten-ID',
      add: 'Hinzufügen',
      operation: 'Operation',
      run: 'Ausführen',
      save: 'Speichern',
      title: 'ID:',
      beginDescription: 'Hier beginnt der Flow.',
      answerDescription:
        'Komponente als Schnittstelle zwischen Mensch und Bot, die Eingaben entgegennimmt und Antworten ausgibt.',
      retrievalDescription:
        'Komponente zum Abrufen von Informationen aus ausgewählten Wissensdatenbanken.',
      generateDescription:
        'Komponente zur Generierung von Antworten durch das LLM.',
      categorizeDescription:
        'Komponente zur Klassifizierung von Benutzereingaben in vordefinierte Kategorien.',
      relevantDescription:
        'Komponente zur Bewertung der Relevanz der vorherigen Ausgabe für die aktuelle Anfrage.',
      rewriteQuestionDescription:
        'Komponente zur Umformulierung von Benutzerfragen basierend auf dem bisherigen Dialog.',
      messageDescription:
        'Diese Komponente gibt das finale Ergebnis des Workflows zusammen mit einer Nachricht aus.',
      keywordDescription:
        'Komponente zum Abrufen der Top-N-Suchergebnisse aus der Benutzereingabe.',
      switchDescription:
        'Komponente zur bedingten Steuerung des Ausführungsflusses.',
      wikipediaDescription:
        'Komponente zur Suche auf wikipedia.org.',
      promptText:
        `Bitte fasse die folgenden Absätze zusammen. Achte auf Zahlen und erfinde nichts:
    {input}
    Obenstehend ist der Inhalt, den du zusammenfassen sollst.`,
      createGraph: 'Agent erstellen',
      createFromTemplates: 'Aus Vorlage erstellen',
      retrieval: 'Abrufen',
      generate: 'Generieren',
      answer: 'Interagieren',
      categorize: 'Kategorisieren',
      rewriteQuestion: 'Umformulieren',
      rewrite: 'Umformulieren',
      begin: 'Start',
      message: 'Nachricht',
      blank: 'Leer',
      createFromNothing: 'Agent von Grund auf erstellen',
      addItem: 'Element hinzufügen',
      addSubItem: 'Unterelement hinzufügen',
      nameRequiredMsg: 'Name ist erforderlich',
      nameRepeatedMsg: 'Der Name darf nicht doppelt vorkommen',
      keywordExtract: 'Schlüsselwort',
      keywordExtractDescription:
        'Komponente zur Extraktion von Schlüsselwörtern aus einer Benutzeranfrage.',
      baidu: 'Baidu',
      duckDuckGo: 'DuckDuckGo',
      searXNG: 'SearXNG',
      pdfGenerator: 'Dokumentengenerator',
      subtitle: 'Untertitel',
      logoImage: 'Logo-Bild',
      logoPosition: 'Logo-Position',
      logoWidth: 'Logo-Breite',
      logoHeight: 'Logo-Höhe',
      fontFamily: 'Schriftart',
      fontSize: 'Schriftgröße',
      titleFontSize: 'Titel-Schriftgröße',
      pageSize: 'Seitengröße',
      orientation: 'Ausrichtung',
      marginTop: 'Oberer Rand',
      marginBottom: 'Unterer Rand',
      filename: 'Dateiname',
      outputDirectory: 'Ausgabeverzeichnis',
      addPageNumbers: 'Seitenzahlen hinzufügen',
      addTimestamp: 'Zeitstempel hinzufügen',
      watermarkText: 'Wasserzeichen-Text',
      channel: 'Kanal',
      channelTip:
        'Text- oder Nachrichtensuche basierend auf der Eingabe der Komponente',
      text: 'Text',
      news: 'Nachrichten',
      messageHistoryWindowSize: 'Nachrichtenfenstergröße',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      email: 'E-Mail',
      arXiv: 'ArXiv',
      sortBy: 'Sortieren nach',
      relevance: 'Relevanz',
      google: 'Google',
      bing: 'Bing',
      apiKey: 'API-SCHLÜSSEL',
      country: 'Land & Region',
      language: 'Sprache',
      googleScholar: 'Google Scholar',
      yearLow: 'Jahr (von)',
      yearHigh: 'Jahr (bis)',
      patents: 'Patente',
      data: 'Daten',
      deepL: 'DeepL',
      authKey: 'Auth-Schlüssel',
      sourceLang: 'Quellsprache',
      targetLang: 'Zielsprache',
      gitHub: 'GitHub',
      baiduFanyi: 'Baidu Fanyi',
      appid: 'App-ID',
      secretKey: 'Geheimer Schlüssel',
      domain: 'Domain',
      transType: 'Übersetzungstyp',
      baiduSecretKeyOptions: {
        translate: 'Allgemeine Übersetzung',
        fieldtranslate: 'Fachübersetzung',
      },
      baiduDomainOptions: {
        it: 'Informationstechnologie',
        finance: 'Finanzen und Wirtschaft',
        machinery: 'Maschinenbau',
        senimed: 'Biomedizin',
        novel: 'Online-Literatur',
        academic: 'Wissenschaftliche Arbeit',
        aerospace: 'Luft- und Raumfahrt',
        wiki: 'Geistes- und Sozialwissenschaften',
        news: 'Nachrichten und Informationen',
        law: 'Gesetze und Vorschriften',
        contract: 'Vertrag',
      },
      baiduSourceLangOptions: {
        auto: 'Automatisch erkennen',
        zh: 'Chinesisch',
        en: 'Englisch',
        yue: 'Kantonesisch',
        wyw: 'Klassisches Chinesisch',
        jp: 'Japanisch',
        kor: 'Koreanisch',
        fra: 'Französisch',
        spa: 'Spanisch',
        th: 'Thailändisch',
        ara: 'Arabisch',
        ru: 'Russisch',
        pt: 'Portugiesisch',
        de: 'Deutsch',
        it: 'Italienisch',
        el: 'Griechisch',
        nl: 'Niederländisch',
        pl: 'Polnisch',
        bul: 'Bulgarisch',
        est: 'Estnisch',
        dan: 'Dänisch',
        fin: 'Finnisch',
        cs: 'Tschechisch',
        rom: 'Rumänisch',
        slo: 'Slowenisch',
        swe: 'Schwedisch',
        hu: 'Ungarisch',
        cht: 'Traditionelles Chinesisch',
        vie: 'Vietnamesisch',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'Eine Komponente, die Wetterinformationen wie Temperatur und Luftqualität von https://www.qweather.com/ abruft.',
      lang: 'Sprache',
      type: 'Typ',
      webApiKey: 'Web-API-Schlüssel',
      userType: 'Benutzertyp',
      timePeriod: 'Zeitraum',
      qWeatherLangOptions: {
        zh: 'Vereinfachtes Chinesisch',
        'zh-hant': 'Traditionelles Chinesisch',
        en: 'Englisch',
        de: 'Deutsch',
        es: 'Spanisch',
        fr: 'Französisch',
        it: 'Italienisch',
        ja: 'Japanisch',
        ko: 'Koreanisch',
        ru: 'Russisch',
        hi: 'Hindi',
        th: 'Thailändisch',
        ar: 'Arabisch',
        pt: 'Portugiesisch',
        bn: 'Bengalisch',
        ms: 'Malaiisch',
        nl: 'Niederländisch',
        el: 'Griechisch',
        la: 'Lateinisch',
        sv: 'Schwedisch',
        id: 'Indonesisch',
        pl: 'Polnisch',
        tr: 'Türkisch',
        cs: 'Tschechisch',
        et: 'Estnisch',
        vi: 'Vietnamesisch',
        fil: 'Philippinisch',
        fi: 'Finnisch',
        he: 'Hebräisch',
        is: 'Isländisch',
        nb: 'Norwegisch',
      },
      qWeatherTypeOptions: {
        weather: 'Wettervorhersage',
        indices: 'Wetter-Lebensindex',
        airquality: 'Luftqualität',
      },
      qWeatherUserTypeOptions: {
        free: 'Kostenloser Abonnent',
        paid: 'Zahlender Abonnent',
      },
      qWeatherTimePeriodOptions: {
        now: 'Jetzt',
        '3d': '3 Tage',
        '7d': '7 Tage',
        '10d': '10 Tage',
        '15d': '12 Tage',
        '30d': '30 Tage',
      },
      publish: 'API',
      exeSQL: 'ExeSQL',
      exeSQLDescription:
        'Eine Komponente, die SQL-Abfragen in einer relationalen Datenbank ausführt und Abfragen von MySQL, PostgreSQL oder MariaDB unterstützt.',
      dbType: 'Datenbanktyp',
      database: 'Datenbank',
      username: 'Benutzername',
      host: 'Host',
      port: 'Port',
      password: 'Passwort',
      switch: 'Schalter',
      logicalOperator: 'Logischer Operator',
      switchOperatorOptions: {
        equal: 'Gleich',
        notEqual: 'Ungleich',
        gt: 'Größer als',
        ge: 'Größer gleich',
        lt: 'Kleiner als',
        le: 'Kleiner gleich',
        contains: 'Enthält',
        notContains: 'Enthält nicht',
        startWith: 'Beginnt mit',
        endWith: 'Endet mit',
        empty: 'Ist leer',
        notEmpty: 'Nicht leer',
      },
      switchLogicOperatorOptions: {
        and: 'UND',
        or: 'ODER',
      },
      operator: 'Operator',
      value: 'Wert',
      useTemplate: 'Diese Vorlage verwenden',
      wenCai: 'WenCai',
      queryType: 'Abfragetyp',
      wenCaiDescription:
        'Eine Komponente, die Finanzinformationen, einschließlich Aktienkursen und Finanzierungsnachrichten, von einer Vielzahl von Finanzwebsites abruft.',
      wenCaiQueryTypeOptions: {
        stock: 'Aktie',
        zhishu: 'Index',
        fund: 'Fonds',
        hkstock: 'Hongkong-Aktien',
        usstock: 'US-Aktienmarkt',
        threeboard: 'Neuer OTC-Markt',
        conbond: 'Wandelanleihe',
        insurance: 'Versicherung',
        futures: 'Futures',
        lccp: 'Finanzierung',
        foreign_exchange: 'Fremdwährung',
      },
      akShare: 'AkShare',
      akShareDescription:
        'Eine Komponente, die Nachrichten über Aktien von https://www.eastmoney.com/ abruft.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'Eine Komponente, die Informationen über ein börsennotiertes Unternehmen anhand seines Tickersymbols abfragt.',
      crawler: 'Web-Crawler',
      crawlerDescription:
        'Eine Komponente, die HTML-Quellcode von einer angegebenen URL crawlt.',
      proxy: 'Proxy',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'Inhalt',
      },
      extractType: 'Extraktionstyp',
      info: 'Info',
      history: 'Verlauf',
      financials: 'Finanzen',
      balanceSheet: 'Bilanz',
      cashFlowStatement: 'Kapitalflussrechnung',
      jin10: 'Jin10',
      jin10Description:
        'Eine Komponente, die Finanzinformationen von der Jin10 Open Platform abruft, einschließlich Nachrichtenaktualisierungen, Kalendern, Kursen und Referenzen.',
      flashType: 'Flash-Typ',
      filter: 'Filter',
      contain: 'Enthalten',
      calendarType: 'Kalendertyp',
      calendarDatashape: 'Kalender-Datenform',
      symbolsDatatype: 'Symboldatentyp',
      symbolsType: 'Symboltyp',
      jin10TypeOptions: {
        flash: 'Schnellnachrichten',
        calendar: 'Kalender',
        symbols: 'Kurse',
        news: 'Referenz',
      },
      jin10FlashTypeOptions: {
        '1': 'Marktnachrichten',
        '2': 'Futures-Nachrichten',
        '3': 'US-Hongkong-Nachrichten',
        '4': 'A-Aktien-Nachrichten',
        '5': 'Rohstoff- und Devisennachrichten',
      },
      jin10CalendarTypeOptions: {
        cj: 'Makroökonomischer Datenkalender',
        qh: 'Futures-Kalender',
        hk: 'Hongkong-Aktienmarktkalender',
        us: 'US-Aktienmarktkalender',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Daten',
        event: 'Ereignis',
        holiday: 'Feiertag',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Rohstoffkurse',
        FOREX: 'Devisenkurse',
        FUTURE: 'Internationale Marktkurse',
        CRYPTO: 'Kryptowährungskurse',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Rohstoffliste',
        quotes: 'Aktuelle Marktkurse',
      },
      concentrator: 'Konzentrator',
      concentratorDescription:
        'Eine Komponente, die die Ausgabe der vorgelagerten Komponente empfängt und als Eingabe an die nachgelagerten Komponenten weitergibt.',
      tuShare: 'TuShare',
      tuShareDescription:
        'Eine Komponente, die Finanznahrichten-Kurzmeldungen von führenden Finanzwebsites abruft und bei Branchen- und quantitativer Forschung hilft.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'wallstreetcn',
        '10jqka': 'Straight Flush',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Token',
      src: 'Quelle',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      keyword: 'Schlüsselwort',
      note: 'Notiz',
      noteDescription: 'Notiz',
      notePlaceholder: 'Bitte geben Sie eine Notiz ein',
      invoke: 'Aufrufen',
      invokeDescription:
        'Eine Komponente, die Remote-Dienste aufrufen kann und dabei die Ausgaben anderer Komponenten oder Konstanten als Eingaben verwendet.',
      url: 'URL',
      method: 'Methode',
      timeout: 'Zeitüberschreitung',
      headers: 'Header',
      cleanHtml: 'HTML bereinigen',
      cleanHtmlTip:
        'Wenn die Antwort im HTML-Format vorliegt und nur der Hauptinhalt gewünscht wird, schalten Sie dies bitte ein.',
      invalidUrl:
        'Muss eine gültige URL oder eine URL mit Variablenplatzhaltern im Format {Variablenname} oder {Komponente@Variable} sein',
      reference: 'Referenz',
      input: 'Eingabe',
      output: 'Ausgabe',
      parameter: 'Parameter',
      howUseId: 'Wie verwendet man die Agenten-ID?',
      content: 'Inhalt',
      operationResults: 'Operationsergebnisse',
      autosaved: 'Automatisch gespeichert',
      optional: 'Optional',
      pasteFileLink: 'Dateilink einfügen',
      testRun: 'Testlauf',
      template: 'Vorlage',
      templateDescription:
        'Eine Komponente, die die Ausgabe anderer Komponenten formatiert. 1. Unterstützt Jinja2-Vorlagen, konvertiert zuerst die Eingabe in ein Objekt und rendert dann die Vorlage, 2. Behält gleichzeitig die ursprüngliche Methode der Verwendung von {parameter} Zeichenkettenersetzung bei',
      emailComponent: 'E-Mail',
      emailDescription: 'Sendet eine E-Mail an eine angegebene Adresse.',
      smtpServer: 'SMTP-Server',
      smtpPort: 'SMTP-Port',
      senderEmail: 'Absender-E-Mail',
      authCode: 'Autorisierungscode',
      senderName: 'Absendername',
      toEmail: 'Empfänger-E-Mail',
      ccEmail: 'CC-E-Mail',
      emailSubject: 'Betreff',
      emailContent: 'Inhalt',
      smtpServerRequired: 'Bitte geben Sie die SMTP-Serveradresse ein',
      senderEmailRequired: 'Bitte geben Sie die Absender-E-Mail ein',
      authCodeRequired: 'Bitte geben Sie den Autorisierungscode ein',
      toEmailRequired: 'Bitte geben Sie die Empfänger-E-Mail ein',
      emailContentRequired: 'Bitte geben Sie den E-Mail-Inhalt ein',
      emailSentSuccess: 'E-Mail erfolgreich gesendet',
      emailSentFailed: 'E-Mail konnte nicht gesendet werden',
      dynamicParameters: 'Dynamische Parameter',
      jsonFormatTip:
        'Die vorgelagerte Komponente sollte einen JSON-String im folgenden Format bereitstellen:',
      toEmailTip: 'to_email: Empfänger-E-Mail (Erforderlich)',
      ccEmailTip: 'cc_email: CC-E-Mail (Optional)',
      subjectTip: 'subject: E-Mail-Betreff (Optional)',
      contentTip: 'content: E-Mail-Inhalt (Optional)',
      jsonUploadTypeErrorMessage: 'Bitte laden Sie eine JSON-Datei hoch',
      jsonUploadContentErrorMessage: 'JSON-Dateifehler',
      iteration: 'Iteration',
      iterationDescription:
        'Diese Komponente teilt zunächst die Eingabe durch "Trennzeichen" in ein Array auf. Führt die gleichen Operationsschritte nacheinander für die Elemente im Array aus, bis alle Ergebnisse ausgegeben sind, was als Aufgaben-Batch-Prozessor verstanden werden kann.\n\nZum Beispiel kann innerhalb des Iterationsknotens für lange Textübersetzungen, wenn der gesamte Inhalt in den LLM-Knoten eingegeben wird, das Limit für eine einzelne Konversation erreicht werden. Der vorgelagerte Knoten kann den langen Text zuerst in mehrere Fragmente aufteilen und mit dem Iterationsknoten zusammenarbeiten, um eine Batch-Übersetzung für jedes Fragment durchzuführen, um zu vermeiden, dass das LLM-Nachrichtenlimit für eine einzelne Konversation erreicht wird.',
      delimiterTip:
        'Dieses Trennzeichen wird verwendet, um den Eingabetext in mehrere Textstücke aufzuteilen, von denen jedes als Eingabeelement jeder Iteration ausgeführt wird.',
      delimiterOptions: {
        comma: 'Komma',
        lineBreak: 'Zeilenumbruch',
        tab: 'Tabulator',
        underline: 'Unterstrich',
        diagonal: 'Schrägstrich',
        minus: 'Bindestrich',
        semicolon: 'Semikolon',
      },
      addVariable: 'Variable hinzufügen',
      variableSettings: 'Variableneinstellungen',
      systemPrompt: 'System-Prompt',
      addCategory: 'Kategorie hinzufügen',
      categoryName: 'Kategoriename',
      nextStep: 'Nächster Schritt',
      datatype: 'MIME-Typ der HTTP-Anfrage',
      insertVariableTip: 'Eingabe / Variablen einfügen',
      prompt: 'Prompt',
      promptTip:
        'Verwenden Sie den Systemprompt, um die Aufgabe für das LLM zu beschreiben, festzulegen, wie es antworten soll, und andere verschiedene Anforderungen zu skizzieren. Der Systemprompt wird oft in Verbindung mit Schlüsseln (Variablen) verwendet, die als verschiedene Dateninputs für das LLM dienen. Verwenden Sie einen Schrägstrich `/` oder die (x)-Schaltfläche, um die zu verwendenden Schlüssel anzuzeigen.',
      promptMessage: 'Prompt ist erforderlich',
      runningHintText: 'läuft...🕞',
    },
    footer: {
      profile: 'Alle Rechte vorbehalten @ React',
    },
    layout: {
      file: 'Datei',
      knowledge: 'Wissen',
      chat: 'Chat',
    },
    enterprise: {
      userManagement: 'Benutzerverwaltung',
      enterpriseUsers: 'Enterprise-Benutzer',
      createUser: 'Benutzer erstellen',
      editUser: 'Benutzer bearbeiten',
      deleteUser: 'Benutzer löschen',
      deleteUserConfirmation: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      email: 'E-Mail',
      nickname: 'Spitzname',
      role: 'Rolle',
      accessTags: 'Zugriffs-Tags',
      enterAccessTags: 'Zugriffs-Tags eingeben...',
      addTag: 'Tag hinzufügen',
      createdAt: 'Erstellt am',
      actions: 'Aktionen',
      admin: 'Administrator',
      user: 'Benutzer',
      password: 'Passwort',
      noUsersFound: 'Keine Benutzer gefunden',
      createUserDescription: 'Erstellen Sie einen neuen Benutzer mit Rolle und Zugriffs-Tags.',
      editUserDescription: 'Benutzerinformationen und Zugriffsrechte aktualisieren.',
      userCreatedSuccess: 'Benutzer erfolgreich erstellt',
      userUpdatedSuccess: 'Benutzer erfolgreich aktualisiert',
      userDeletedSuccess: 'Benutzer erfolgreich gelöscht',
      errorCreatingUser: 'Fehler beim Erstellen des Benutzers',
      errorUpdatingUser: 'Fehler beim Aktualisieren des Benutzers',
      errorDeletingUser: 'Fehler beim Löschen des Benutzers',
      documentAccessTags: 'Dokument-Zugriffs-Tags',
      documentAccessTagsDescription: 'Weisen Sie Zugriffs-Tags zu, um zu steuern, welche Benutzer dieses Dokument abrufen können.',
    },
    customFunctions: {
      uploadFilesAndFolders: 'Dateien & Ordner hochladen',
      dragAndDropTitle: 'Dateien oder Ordner hierher ziehen',
      dropFilesOrFolders: 'Dateien oder Ordner hier ablegen',
      uploadDescription: 'Unterstützt einzelne Dateien, mehrere Dateien oder ganze Ordner',
      clickOrDragDescription: 'Klicken für Dateiauswahl, oder Buttons unten für Ordnerauswahl nutzen',
      clickToSelectFiles: 'Klicken um Dateien auszuwählen',
      selectFiles: 'Dateien auswählen',
      selectFolder: 'Ordner auswählen',
      selectedFiles: '{{count}} Datei(en) ausgewählt',
      fileTooLarge: 'Datei "{{name}}" ist zu groß (max {{maxSize}})',
      tooManyFiles: 'Es können nicht mehr als {{count}} Dateien hochgeladen werden',
      clearAll: 'Alle löschen',
      folderUpload: 'Ordner-Upload',
      folderUploadDescription: 'Wählen Sie einen Ordner aus, um alle darin enthaltenen Dateien hochzuladen',
    },

    admin: {
      accessTags: 'Zugriffs-Tags',
      accessTagManagement: 'Zugriffs-Tags verwalten',
      accessTagsHelp:
        'Rolle und Zugriffs-Tags steuern, welche Dokumente ein Benutzer lesen darf. Ein Benutzer sieht Dokumente mit passenden Tags sowie alle Dokumente ohne Tags.',
      accessTagsHint:
        'Leer lassen, damit der Benutzer nur Dokumente ohne Tags sieht.',
      addAccessTag: 'Tag eingeben und Enter drücken...',
      allAccess: 'Voller Zugriff',
      noAccessTags: 'Keine Tags',
      editAccess: 'Zugriff bearbeiten',
      roleAdmin: 'Administrator',
      roleUser: 'Benutzer',
      roleViewer: 'Betrachter',
      save: 'Speichern',
      loginTitle: 'Admin-Konsole für optimAIse RAG',
      title: 'optimAIse RAG',
      confirm: 'Bestätigen',
      close: 'Schließen',
      yes: 'Ja',
      no: 'Nein',
      delete: 'Löschen',
      cancel: 'Abbrechen',
      reset: 'Zurücksetzen',
      import: 'Importieren',
      description: 'Beschreibung',
      noDescription: 'Keine Beschreibung',

      resourceType: {
        dataset: 'Datensatz',
        chat: 'Chat',
        agent: 'Agent',
        search: 'Suche',
        file: 'Datei',
        team: 'Team',
        memory: 'Speicher',
      },

      permissionType: {
        enable: 'Aktivieren',
        read: 'Lesen',
        write: 'Schreiben',
        share: 'Teilen',
      },

      serviceStatus: 'Service-Status',
      userManagement: 'Benutzerverwaltung',
      registrationWhitelist: 'Registrierungs-Whitelist',
      roles: 'Rollen',
      monitoring: 'Überwachung',
      llmSettings: 'LLM-Einstellungen',
      kbSettings: 'Wissensdatenbanken',
      kbSettingsNotice:
        'Erstelle Wissensdatenbanken und binde Datenquellen für deine Nutzer an. Nutzer wählen in ihren Chat-Einstellungen nur noch aus, welche Wissensdatenbank abgefragt wird.',
      createKb: 'Wissensdatenbank erstellen',
      kbSystemWide: 'Systemweit',
      kbSystemWideDescription:
        'Standardmäßig für alle Nutzer sichtbar. Ausschalten, um diese Wissensdatenbank auf bestimmte Nutzer zu beschränken.',
      kbAuthorizedUsers: 'Berechtigte Nutzer',
      kbAuthorizedUsersPlaceholder: 'Nutzer auswählen...',
      kbAuthorizedUsersRequired: 'Mindestens einen berechtigten Nutzer auswählen',
      kbRestrictedCount: 'Beschränkt ({{count}} Nutzer)',
      kbOwner: 'Besitzer',
      manageKb: 'Datenquellen verwalten',
      noKbConfigured: 'Noch keine Wissensdatenbanken.',
      deleteKbTitle: 'Wissensdatenbank löschen',
      deleteKbConfirm:
        '„{{name}}“ und alle zugehörigen Dokumente löschen? Dies kann nicht rückgängig gemacht werden.',
      dataSourcesNotice:
        'Zusätzliche Datenquellen hier anbinden (Google Drive, Gmail, ...)',

      back: 'Zurück',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      enable: 'Aktivieren',
      disable: 'Deaktivieren',
      all: 'Alle',
      actions: 'Aktionen',
      newUser: 'Neuer Benutzer',
      email: 'E-Mail',
      name: 'Name',
      nickname: 'Spitzname',
      status: 'Status',
      id: 'ID',
      serviceType: 'Service-Typ',
      host: 'Host',
      port: 'Port',

      role: 'Rolle',
      user: 'Benutzer',
      superuser: 'Superuser',

      createTime: 'Erstellungszeit',
      lastLoginTime: 'Letzte Anmeldung',
      lastUpdateTime: 'Letzte Aktualisierung',

      isAnonymous: 'Ist anonym',
      isSuperuser: 'Ist Superuser',

      deleteUser: 'Benutzer löschen',
      deleteUserConfirmation: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',

      createNewUser: 'Neuen Benutzer erstellen',
      changePassword: 'Passwort ändern',
      newPassword: 'Neues Passwort',
      confirmNewPassword: 'Neues Passwort bestätigen',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',

      invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein!',
      passwordRequired: 'Bitte geben Sie Ihr Passwort ein!',
      nicknameRequired: 'Bitte geben Sie einen Spitznamen ein!',
      passwordMinLength: 'Das Passwort muss mehr als 8 Zeichen enthalten.',
      confirmPasswordRequired: 'Bitte bestätigen Sie Ihr Passwort!',
      confirmPasswordDoNotMatch: 'Die eingegebenen Passwörter stimmen nicht überein!',

      read: 'Lesen',
      write: 'Schreiben',
      share: 'Teilen',
      create: 'Erstellen',

      extraInfo: 'Zusätzliche Informationen',
      serviceDetail: `Service {{name}} Details`,
      taskExecutorDetail: 'Task-Executor-Details',

      whitelistManagement: 'Whitelist-Verwaltung',
      exportAsExcel: 'Als Excel exportieren',
      importFromExcel: 'Aus Excel importieren',
      createEmail: 'E-Mail erstellen',
      deleteEmail: 'E-Mail löschen',
      editEmail: 'E-Mail bearbeiten',
      deleteWhitelistEmailConfirmation: 'Sind Sie sicher, dass Sie diese E-Mail aus der Whitelist löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

      importWhitelist: 'Whitelist importieren (Excel)',
      importSelectExcelFile: 'Excel-Datei (.xlsx)',
      importOverwriteExistingEmails: 'Bestehende E-Mails überschreiben',
      importInvalidExcelFile: 'Bitte wählen Sie eine gültige Excel-Datei aus',
      importFileRequired: 'Bitte wählen Sie eine Datei zum Importieren aus',
      importFileTips: 'Die Datei muss eine einzelne Kopfzeile namens <code>email</code> enthalten.',

      chunkNum: 'Chunks',
      docNum: 'Dokumente',
      tokenNum: 'Verwendete Tokens',
      language: 'Sprache',
      createDate: 'Erstellungsdatum',
      updateDate: 'Aktualisierungsdatum',
      permission: 'Berechtigung',

      agentTitle: 'Agenten-Titel',
      canvasCategory: 'Canvas-Kategorie',
      dialogTitel: 'Chat-Apps',

      newRole: 'Neue Rolle',
      addNewRole: 'Neue Rolle hinzufügen',
      roleName: 'Rollenname',
      roleNameRequired: 'Rollenname ist erforderlich',
      resources: 'Ressourcen',

      editRoleDescription: 'Rollenbeschreibung bearbeiten',
      deleteRole: 'Rolle löschen',
      deleteRoleConfirmation: 'Sind Sie sicher, dass Sie diese Rolle löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

      alive: 'Aktiv',
      timeout: 'Zeitüberschreitung',
      fail: 'Fehler',

      promptConfig: 'Prompt-Konfiguration',
      llmSetting: 'LLM-Einstellungen',
      similarityThreshold: 'Ähnlichkeitsschwelle',
      vectorSimilarityWeight: 'Gewichtung der Vektorähnlichkeit',
      topN: 'Top-N',
      topK: 'Top-K',
      chatLanguage: 'Chat-Sprache',

      editSettings: "Chat-Einstellungen bearbeiten",
      systemPrompt: "System-Prompt",
      temperature: "Temperatur",
      topP: "Top-P",
      icon: "Icon",
      llmId: "LLM-ID",
      tocEnhance: "TOC-Erweiterung",
      frequencyPenalty: "Häufigkeitsbestrafung",
      presencePenalty: "Präsenzbestrafung",
      maxTokens: "Maximale Tokens",
      
    },
  },
  
  enterprise: {
    userManagement: 'Benutzerverwaltung',
    enterpriseUsers: 'Unternehmensbenutzer',
    createUser: 'Benutzer erstellen',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer löschen',
    deleteUserConfirmation: 'Möchten Sie diesen Benutzer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    email: 'E-Mail',
    nickname: 'Spitzname',
    role: 'Rolle',
    accessTags: 'Zugriffstags',
    enterAccessTags: 'Zugriffstags eingeben...',
    addTag: 'Tag hinzufügen',
    createdAt: 'Erstellt am',
    actions: 'Aktionen',
    admin: 'Administrator',
    user: 'Benutzer',
    password: 'Passwort',
    noUsersFound: 'Keine Benutzer gefunden',
    createUserDescription: 'Erstellen Sie einen neuen Benutzer mit Rolle und Zugriffstags.',
    editUserDescription: 'Aktualisieren Sie Benutzerinformationen und Zugriffsberechtigungen.',
    userCreatedSuccess: 'Benutzer erfolgreich erstellt',
    userUpdatedSuccess: 'Benutzer erfolgreich aktualisiert',
    userDeletedSuccess: 'Benutzer erfolgreich gelöscht',
    errorCreatingUser: 'Fehler beim Erstellen des Benutzers',
    errorUpdatingUser: 'Fehler beim Aktualisieren des Benutzers',
    errorDeletingUser: 'Fehler beim Löschen des Benutzers',
    documentAccessTags: 'Dokumenten-Zugriffstags',
    documentAccessTagsDescription: 'Weisen Sie Zugriffstags zu, um zu steuern, welche Benutzer dieses Dokument abrufen können.',
  },
  customFunctions: {
    uploadFilesAndFolders: 'Dateien & Ordner hochladen',
    dragAndDropTitle: 'Dateien oder Ordner hierher ziehen und ablegen',
    dropFilesOrFolders: 'Dateien oder Ordner hier ablegen',
    uploadDescription: 'Unterstützt einzelne Dateien, mehrere Dateien oder ganze Ordner',
    clickOrDragDescription: 'Klicken Sie, um Dateien auszuwählen, oder verwenden Sie die untenstehenden Schaltflächen zur Ordnerauswahl',
    clickToSelectFiles: 'Klicken Sie, um Dateien auszuwählen',
    selectFiles: 'Dateien auswählen',
    selectFolder: 'Ordner auswählen',
    selectedFiles: '{{count}} Datei(en) ausgewählt',
    fileTooLarge: 'Datei "{{name}}" ist zu groß (max {{maxSize}})',
    tooManyFiles: 'Es können nicht mehr als {{count}} Dateien hochgeladen werden',
    clearAll: 'Alles löschen',
    folderUpload: 'Ordner-Upload',
    folderUploadDescription: 'Wählen Sie einen Ordner aus, um alle darin enthaltenen Dateien hochzuladen',
  },
};
